/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as ChartRenderRouteImport } from './routes/chart-render'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as AuthenticatedLayoutRouteImport } from './routes/_authenticated/_layout'
import { Route as AuthenticatedAddToCampaignRouteImport } from './routes/_authenticated/add-to-campaign'
import { Route as AuthenticatedImpersonateRouteImport } from './routes/_authenticated/impersonate'
import { Route as AuthenticatedPendingInvitesRouteImport } from './routes/_authenticated/pending-invites'
import { Route as OauthConsentRouteImport } from './routes/oauth.consent'
import { Route as ResetPasswordTokenRouteImport } from './routes/reset-password.$token'
import { Route as AuthenticatedLayoutIndexRouteImport } from './routes/_authenticated/_layout/index'
import { Route as AuthenticatedLayoutCampaignsRouteRouteImport } from './routes/_authenticated/_layout/campaigns/route'
import { Route as AuthenticatedLayoutPerformanceRouteRouteImport } from './routes/_authenticated/_layout/performance/route'
import { Route as AuthenticatedClientSlugRouteImport } from './routes/_authenticated/client.$slug'
import { Route as AuthenticatedNewLayoutRouteImport } from './routes/_authenticated/new/_layout'
import { Route as AuthenticatedWelcomeIndexRouteImport } from './routes/_authenticated/welcome/index'
import { Route as AuthenticatedWelcomeOrganizationNameRouteImport } from './routes/_authenticated/welcome/organization-name'
import { Route as InviteSignupCodeIndexRouteImport } from './routes/invite-signup/$code/index'
import { Route as AuthenticatedLayoutAdminIndexRouteImport } from './routes/_authenticated/_layout/admin/index'
import { Route as AuthenticatedLayoutAdminKeywordsRouteImport } from './routes/_authenticated/_layout/admin/keywords'
import { Route as AuthenticatedLayoutAdminSchedulerRouteImport } from './routes/_authenticated/_layout/admin/scheduler'
import { Route as AuthenticatedLayoutAssetsIndexRouteImport } from './routes/_authenticated/_layout/assets/index'
import { Route as AuthenticatedLayoutBusinessIndexRouteImport } from './routes/_authenticated/_layout/business/index'
import { Route as AuthenticatedLayoutBusinessOrgIdRouteImport } from './routes/_authenticated/_layout/business/$orgId'
import { Route as AuthenticatedLayoutCampaignsIndexRouteImport } from './routes/_authenticated/_layout/campaigns/index'
import { Route as AuthenticatedLayoutCampaignsCampaignslugRouteImport } from './routes/_authenticated/_layout/campaigns/$campaignslug'
import { Route as AuthenticatedLayoutCompetitorsIndexRouteImport } from './routes/_authenticated/_layout/competitors/index'
import { Route as AuthenticatedLayoutCompetitorsCompetitorIdRouteImport } from './routes/_authenticated/_layout/competitors/$competitorId'
import { Route as AuthenticatedLayoutComponentsIndexRouteImport } from './routes/_authenticated/_layout/components/index'
import { Route as AuthenticatedLayoutComponentsAnimationsRouteImport } from './routes/_authenticated/_layout/components/animations'
import { Route as AuthenticatedLayoutComponentsButtonsRouteImport } from './routes/_authenticated/_layout/components/buttons'
import { Route as AuthenticatedLayoutComponentsColorsRouteImport } from './routes/_authenticated/_layout/components/colors'
import { Route as AuthenticatedLayoutComponentsFormsRouteImport } from './routes/_authenticated/_layout/components/forms'
import { Route as AuthenticatedLayoutComponentsIconographyRouteImport } from './routes/_authenticated/_layout/components/iconography'
import { Route as AuthenticatedLayoutComponentsTablesRouteImport } from './routes/_authenticated/_layout/components/tables'
import { Route as AuthenticatedLayoutComponentsTypographyRouteImport } from './routes/_authenticated/_layout/components/typography'
import { Route as AuthenticatedLayoutComponentsWizardsRouteImport } from './routes/_authenticated/_layout/components/wizards'
import { Route as AuthenticatedLayoutMetaCampaignsIndexRouteImport } from './routes/_authenticated/_layout/meta-campaigns/index'
import { Route as AuthenticatedLayoutNotificationsIndexRouteImport } from './routes/_authenticated/_layout/notifications/index'
import { Route as AuthenticatedLayoutNotificationsNotificationIdRouteImport } from './routes/_authenticated/_layout/notifications/$notificationId'
import { Route as AuthenticatedLayoutOptimizationsIndexRouteImport } from './routes/_authenticated/_layout/optimizations/index'
import { Route as AuthenticatedLayoutOrganizationsIndexRouteImport } from './routes/_authenticated/_layout/organizations/index'
import { Route as AuthenticatedLayoutOrganizationsOrgIdRouteImport } from './routes/_authenticated/_layout/organizations/$orgId'
import { Route as AuthenticatedLayoutPerformanceBetaIndexRouteImport } from './routes/_authenticated/_layout/performance-beta/index'
import { Route as AuthenticatedLayoutPerformanceConsolidatedIndexRouteImport } from './routes/_authenticated/_layout/performance-consolidated/index'
import { Route as AuthenticatedLayoutPerformanceIndexRouteImport } from './routes/_authenticated/_layout/performance/index'
import { Route as AuthenticatedLayoutReportsIndexRouteImport } from './routes/_authenticated/_layout/reports/index'
import { Route as AuthenticatedLayoutReportsReportIdRouteImport } from './routes/_authenticated/_layout/reports/$reportId'
import { Route as AuthenticatedLayoutSettingsIndexRouteImport } from './routes/_authenticated/_layout/settings/index'
import { Route as AuthenticatedLayoutSettingsLayoutRouteImport } from './routes/_authenticated/_layout/settings/_layout'
import { Route as AuthenticatedLayoutSetupIndexRouteImport } from './routes/_authenticated/_layout/setup/index'
import { Route as AuthenticatedLayoutStrategyIndexRouteImport } from './routes/_authenticated/_layout/strategy/index'
import { Route as AuthenticatedLayoutTasksIndexRouteImport } from './routes/_authenticated/_layout/tasks/index'
import { Route as AuthenticatedLayoutTasksLayoutRouteImport } from './routes/_authenticated/_layout/tasks/_layout'
import { Route as AuthenticatedNewLayoutBrandRouteImport } from './routes/_authenticated/new/_layout/brand'
import { Route as AuthenticatedLayoutCampaignsMetaMetaCampaignSlugRouteImport } from './routes/_authenticated/_layout/campaigns/meta/$metaCampaignSlug'
import { Route as AuthenticatedLayoutPerformanceCampaignSlugIndexRouteImport } from './routes/_authenticated/_layout/performance/$campaignSlug/index'
import { Route as AuthenticatedLayoutSettingsLayoutAccountRouteImport } from './routes/_authenticated/_layout/settings/_layout/account'
import { Route as AuthenticatedLayoutSettingsLayoutBillingRouteImport } from './routes/_authenticated/_layout/settings/_layout/billing'
import { Route as AuthenticatedLayoutSettingsLayoutBudgetRouteImport } from './routes/_authenticated/_layout/settings/_layout/budget'
import { Route as AuthenticatedLayoutSettingsLayoutCompanyRouteImport } from './routes/_authenticated/_layout/settings/_layout/company'
import { Route as AuthenticatedLayoutSettingsLayoutConversionsRouteImport } from './routes/_authenticated/_layout/settings/_layout/conversions'
import { Route as AuthenticatedLayoutSettingsLayoutIntegrationsRouteImport } from './routes/_authenticated/_layout/settings/_layout/integrations'
import { Route as AuthenticatedLayoutSettingsLayoutNotificationRouteImport } from './routes/_authenticated/_layout/settings/_layout/notification'
import { Route as AuthenticatedLayoutSettingsLayoutReportsRouteImport } from './routes/_authenticated/_layout/settings/_layout/reports'
import { Route as AuthenticatedLayoutSettingsLayoutTeamRouteImport } from './routes/_authenticated/_layout/settings/_layout/team'
import { Route as AuthenticatedLayoutTasksLayoutNegativeKeywordsRouteImport } from './routes/_authenticated/_layout/tasks/_layout/negative-keywords'
import { Route as AuthenticatedLayoutTasksLayoutNewRouteImport } from './routes/_authenticated/_layout/tasks/_layout/new'
import { Route as AuthenticatedLayoutTasksLayoutRecommendationsRouteImport } from './routes/_authenticated/_layout/tasks/_layout/recommendations'
import { Route as AuthenticatedNewLayoutCampaignslugGeneratingRouteImport } from './routes/_authenticated/new/_layout/$campaignslug/generating'
import { Route as AuthenticatedNewLayoutCampaignIndexRouteImport } from './routes/_authenticated/new/_layout/campaign/index'
import { Route as AuthenticatedNewLayoutCampaignBrandRouteImport } from './routes/_authenticated/new/_layout/campaign/brand'
import { Route as AuthenticatedNewLayoutCampaignCompetitorRouteImport } from './routes/_authenticated/new/_layout/campaign/competitor'
import { Route as AuthenticatedNewLayoutCampaignHipoRouteImport } from './routes/_authenticated/new/_layout/campaign/hipo'
import { Route as AuthenticatedNewLayoutCampaignIcpRouteImport } from './routes/_authenticated/new/_layout/campaign/icp'
import { Route as AuthenticatedNewLayoutCampaignLocationRouteImport } from './routes/_authenticated/new/_layout/campaign/location'
import { Route as AuthenticatedNewLayoutCampaignMetaRouteImport } from './routes/_authenticated/new/_layout/campaign/meta'
import { Route as AuthenticatedNewLayoutCampaignProspectingRouteImport } from './routes/_authenticated/new/_layout/campaign/prospecting'
import { Route as AuthenticatedNewLayoutDeployingSlugRouteImport } from './routes/_authenticated/new/_layout/deploying/$slug'
import { Route as AuthenticatedNewLayoutOnboardingIndexRouteImport } from './routes/_authenticated/new/_layout/onboarding/index'
import { Route as AuthenticatedNewLayoutOnboardingGeneratingRouteImport } from './routes/_authenticated/new/_layout/onboarding/generating'
import { Route as AuthenticatedLayoutCampaignsGoogleCampaignslugSlugRouteImport } from './routes/_authenticated/_layout/campaigns/google/$campaignslug/_slug'
import { Route as AuthenticatedLayoutCampaignsGoogleCampaignslugSlugIndexRouteImport } from './routes/_authenticated/_layout/campaigns/google/$campaignslug/_slug/index'
import { Route as AuthenticatedLayoutCampaignsMetaMetaCampaignSlugAdAdIdRouteImport } from './routes/_authenticated/_layout/campaigns/meta/$metaCampaignSlug_.ad.$adId'
import { Route as AuthenticatedLayoutCampaignsMetaMetaCampaignSlugAdsetAdSetIdRouteImport } from './routes/_authenticated/_layout/campaigns/meta/$metaCampaignSlug_.adset.$adSetId'
import { Route as AuthenticatedLayoutSettingsLayoutIntegrationsHubspotCallbackRouteImport } from './routes/_authenticated/_layout/settings/_layout/integrations/hubspot/callback'
import { Route as AuthenticatedLayoutSettingsLayoutIntegrationsMetaCallbackRouteImport } from './routes/_authenticated/_layout/settings/_layout/integrations/meta/callback'
import { Route as AuthenticatedLayoutCampaignsGoogleCampaignslugSlugAdAdIdRouteImport } from './routes/_authenticated/_layout/campaigns/google/$campaignslug/_slug/ad/$adId'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const ChartRenderRoute = ChartRenderRouteImport.update({
  id: '/chart-render',
  path: '/chart-render',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const UnsubscribeRoute = UnsubscribeRouteImport.update({
  id: '/unsubscribe',
  path: '/unsubscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedLayoutRoute = AuthenticatedLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAddToCampaignRoute =
  AuthenticatedAddToCampaignRouteImport.update({
    id: '/add-to-campaign',
    path: '/add-to-campaign',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedImpersonateRoute =
  AuthenticatedImpersonateRouteImport.update({
    id: '/impersonate',
    path: '/impersonate',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPendingInvitesRoute =
  AuthenticatedPendingInvitesRouteImport.update({
    id: '/pending-invites',
    path: '/pending-invites',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordTokenRoute = ResetPasswordTokenRouteImport.update({
  id: '/reset-password/$token',
  path: '/reset-password/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedLayoutIndexRoute =
  AuthenticatedLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutCampaignsRouteRoute =
  AuthenticatedLayoutCampaignsRouteRouteImport.update({
    id: '/campaigns',
    path: '/campaigns',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutPerformanceRouteRoute =
  AuthenticatedLayoutPerformanceRouteRouteImport.update({
    id: '/performance',
    path: '/performance',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedClientSlugRoute = AuthenticatedClientSlugRouteImport.update({
  id: '/client/$slug',
  path: '/client/$slug',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNewLayoutRoute = AuthenticatedNewLayoutRouteImport.update({
  id: '/new/_layout',
  path: '/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedWelcomeIndexRoute =
  AuthenticatedWelcomeIndexRouteImport.update({
    id: '/welcome/',
    path: '/welcome/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWelcomeOrganizationNameRoute =
  AuthenticatedWelcomeOrganizationNameRouteImport.update({
    id: '/welcome/organization-name',
    path: '/welcome/organization-name',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const InviteSignupCodeIndexRoute = InviteSignupCodeIndexRouteImport.update({
  id: '/invite-signup/$code/',
  path: '/invite-signup/$code/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedLayoutAdminIndexRoute =
  AuthenticatedLayoutAdminIndexRouteImport.update({
    id: '/admin/',
    path: '/admin/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutAdminKeywordsRoute =
  AuthenticatedLayoutAdminKeywordsRouteImport.update({
    id: '/admin/keywords',
    path: '/admin/keywords',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutAdminSchedulerRoute =
  AuthenticatedLayoutAdminSchedulerRouteImport.update({
    id: '/admin/scheduler',
    path: '/admin/scheduler',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutAssetsIndexRoute =
  AuthenticatedLayoutAssetsIndexRouteImport.update({
    id: '/assets/',
    path: '/assets/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutBusinessIndexRoute =
  AuthenticatedLayoutBusinessIndexRouteImport.update({
    id: '/business/',
    path: '/business/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutBusinessOrgIdRoute =
  AuthenticatedLayoutBusinessOrgIdRouteImport.update({
    id: '/business/$orgId',
    path: '/business/$orgId',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutCampaignsIndexRoute =
  AuthenticatedLayoutCampaignsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLayoutCampaignsRouteRoute,
  } as any)
const AuthenticatedLayoutCampaignsCampaignslugRoute =
  AuthenticatedLayoutCampaignsCampaignslugRouteImport.update({
    id: '/$campaignslug',
    path: '/$campaignslug',
    getParentRoute: () => AuthenticatedLayoutCampaignsRouteRoute,
  } as any)
const AuthenticatedLayoutCompetitorsIndexRoute =
  AuthenticatedLayoutCompetitorsIndexRouteImport.update({
    id: '/competitors/',
    path: '/competitors/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutCompetitorsCompetitorIdRoute =
  AuthenticatedLayoutCompetitorsCompetitorIdRouteImport.update({
    id: '/competitors/$competitorId',
    path: '/competitors/$competitorId',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutComponentsIndexRoute =
  AuthenticatedLayoutComponentsIndexRouteImport.update({
    id: '/components/',
    path: '/components/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutComponentsAnimationsRoute =
  AuthenticatedLayoutComponentsAnimationsRouteImport.update({
    id: '/components/animations',
    path: '/components/animations',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutComponentsButtonsRoute =
  AuthenticatedLayoutComponentsButtonsRouteImport.update({
    id: '/components/buttons',
    path: '/components/buttons',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutComponentsColorsRoute =
  AuthenticatedLayoutComponentsColorsRouteImport.update({
    id: '/components/colors',
    path: '/components/colors',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutComponentsFormsRoute =
  AuthenticatedLayoutComponentsFormsRouteImport.update({
    id: '/components/forms',
    path: '/components/forms',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutComponentsIconographyRoute =
  AuthenticatedLayoutComponentsIconographyRouteImport.update({
    id: '/components/iconography',
    path: '/components/iconography',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutComponentsTablesRoute =
  AuthenticatedLayoutComponentsTablesRouteImport.update({
    id: '/components/tables',
    path: '/components/tables',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutComponentsTypographyRoute =
  AuthenticatedLayoutComponentsTypographyRouteImport.update({
    id: '/components/typography',
    path: '/components/typography',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutComponentsWizardsRoute =
  AuthenticatedLayoutComponentsWizardsRouteImport.update({
    id: '/components/wizards',
    path: '/components/wizards',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutMetaCampaignsIndexRoute =
  AuthenticatedLayoutMetaCampaignsIndexRouteImport.update({
    id: '/meta-campaigns/',
    path: '/meta-campaigns/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutNotificationsIndexRoute =
  AuthenticatedLayoutNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutNotificationsNotificationIdRoute =
  AuthenticatedLayoutNotificationsNotificationIdRouteImport.update({
    id: '/notifications/$notificationId',
    path: '/notifications/$notificationId',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutOptimizationsIndexRoute =
  AuthenticatedLayoutOptimizationsIndexRouteImport.update({
    id: '/optimizations/',
    path: '/optimizations/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutOrganizationsIndexRoute =
  AuthenticatedLayoutOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutOrganizationsOrgIdRoute =
  AuthenticatedLayoutOrganizationsOrgIdRouteImport.update({
    id: '/organizations/$orgId',
    path: '/organizations/$orgId',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutPerformanceBetaIndexRoute =
  AuthenticatedLayoutPerformanceBetaIndexRouteImport.update({
    id: '/performance-beta/',
    path: '/performance-beta/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutPerformanceConsolidatedIndexRoute =
  AuthenticatedLayoutPerformanceConsolidatedIndexRouteImport.update({
    id: '/performance-consolidated/',
    path: '/performance-consolidated/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutPerformanceIndexRoute =
  AuthenticatedLayoutPerformanceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLayoutPerformanceRouteRoute,
  } as any)
const AuthenticatedLayoutReportsIndexRoute =
  AuthenticatedLayoutReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutReportsReportIdRoute =
  AuthenticatedLayoutReportsReportIdRouteImport.update({
    id: '/reports/$reportId',
    path: '/reports/$reportId',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutSettingsIndexRoute =
  AuthenticatedLayoutSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutSettingsLayoutRoute =
  AuthenticatedLayoutSettingsLayoutRouteImport.update({
    id: '/settings/_layout',
    path: '/settings',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutSetupIndexRoute =
  AuthenticatedLayoutSetupIndexRouteImport.update({
    id: '/setup/',
    path: '/setup/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutStrategyIndexRoute =
  AuthenticatedLayoutStrategyIndexRouteImport.update({
    id: '/strategy/',
    path: '/strategy/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutTasksIndexRoute =
  AuthenticatedLayoutTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutTasksLayoutRoute =
  AuthenticatedLayoutTasksLayoutRouteImport.update({
    id: '/tasks/_layout',
    path: '/tasks',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedNewLayoutBrandRoute =
  AuthenticatedNewLayoutBrandRouteImport.update({
    id: '/brand',
    path: '/brand',
    getParentRoute: () => AuthenticatedNewLayoutRoute,
  } as any)
const AuthenticatedLayoutCampaignsMetaMetaCampaignSlugRoute =
  AuthenticatedLayoutCampaignsMetaMetaCampaignSlugRouteImport.update({
    id: '/meta/$metaCampaignSlug',
    path: '/meta/$metaCampaignSlug',
    getParentRoute: () => AuthenticatedLayoutCampaignsRouteRoute,
  } as any)
const AuthenticatedLayoutPerformanceCampaignSlugIndexRoute =
  AuthenticatedLayoutPerformanceCampaignSlugIndexRouteImport.update({
    id: '/$campaignSlug/',
    path: '/$campaignSlug/',
    getParentRoute: () => AuthenticatedLayoutPerformanceRouteRoute,
  } as any)
const AuthenticatedLayoutSettingsLayoutAccountRoute =
  AuthenticatedLayoutSettingsLayoutAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedLayoutSettingsLayoutRoute,
  } as any)
const AuthenticatedLayoutSettingsLayoutBillingRoute =
  AuthenticatedLayoutSettingsLayoutBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedLayoutSettingsLayoutRoute,
  } as any)
const AuthenticatedLayoutSettingsLayoutBudgetRoute =
  AuthenticatedLayoutSettingsLayoutBudgetRouteImport.update({
    id: '/budget',
    path: '/budget',
    getParentRoute: () => AuthenticatedLayoutSettingsLayoutRoute,
  } as any)
const AuthenticatedLayoutSettingsLayoutCompanyRoute =
  AuthenticatedLayoutSettingsLayoutCompanyRouteImport.update({
    id: '/company',
    path: '/company',
    getParentRoute: () => AuthenticatedLayoutSettingsLayoutRoute,
  } as any)
const AuthenticatedLayoutSettingsLayoutConversionsRoute =
  AuthenticatedLayoutSettingsLayoutConversionsRouteImport.update({
    id: '/conversions',
    path: '/conversions',
    getParentRoute: () => AuthenticatedLayoutSettingsLayoutRoute,
  } as any)
const AuthenticatedLayoutSettingsLayoutIntegrationsRoute =
  AuthenticatedLayoutSettingsLayoutIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedLayoutSettingsLayoutRoute,
  } as any)
const AuthenticatedLayoutSettingsLayoutNotificationRoute =
  AuthenticatedLayoutSettingsLayoutNotificationRouteImport.update({
    id: '/notification',
    path: '/notification',
    getParentRoute: () => AuthenticatedLayoutSettingsLayoutRoute,
  } as any)
const AuthenticatedLayoutSettingsLayoutReportsRoute =
  AuthenticatedLayoutSettingsLayoutReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AuthenticatedLayoutSettingsLayoutRoute,
  } as any)
const AuthenticatedLayoutSettingsLayoutTeamRoute =
  AuthenticatedLayoutSettingsLayoutTeamRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => AuthenticatedLayoutSettingsLayoutRoute,
  } as any)
const AuthenticatedLayoutTasksLayoutNegativeKeywordsRoute =
  AuthenticatedLayoutTasksLayoutNegativeKeywordsRouteImport.update({
    id: '/negative-keywords',
    path: '/negative-keywords',
    getParentRoute: () => AuthenticatedLayoutTasksLayoutRoute,
  } as any)
const AuthenticatedLayoutTasksLayoutNewRoute =
  AuthenticatedLayoutTasksLayoutNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedLayoutTasksLayoutRoute,
  } as any)
const AuthenticatedLayoutTasksLayoutRecommendationsRoute =
  AuthenticatedLayoutTasksLayoutRecommendationsRouteImport.update({
    id: '/recommendations',
    path: '/recommendations',
    getParentRoute: () => AuthenticatedLayoutTasksLayoutRoute,
  } as any)
const AuthenticatedNewLayoutCampaignslugGeneratingRoute =
  AuthenticatedNewLayoutCampaignslugGeneratingRouteImport.update({
    id: '/$campaignslug/generating',
    path: '/$campaignslug/generating',
    getParentRoute: () => AuthenticatedNewLayoutRoute,
  } as any)
const AuthenticatedNewLayoutCampaignIndexRoute =
  AuthenticatedNewLayoutCampaignIndexRouteImport.update({
    id: '/campaign/',
    path: '/campaign/',
    getParentRoute: () => AuthenticatedNewLayoutRoute,
  } as any)
const AuthenticatedNewLayoutCampaignBrandRoute =
  AuthenticatedNewLayoutCampaignBrandRouteImport.update({
    id: '/campaign/brand',
    path: '/campaign/brand',
    getParentRoute: () => AuthenticatedNewLayoutRoute,
  } as any)
const AuthenticatedNewLayoutCampaignCompetitorRoute =
  AuthenticatedNewLayoutCampaignCompetitorRouteImport.update({
    id: '/campaign/competitor',
    path: '/campaign/competitor',
    getParentRoute: () => AuthenticatedNewLayoutRoute,
  } as any)
const AuthenticatedNewLayoutCampaignHipoRoute =
  AuthenticatedNewLayoutCampaignHipoRouteImport.update({
    id: '/campaign/hipo',
    path: '/campaign/hipo',
    getParentRoute: () => AuthenticatedNewLayoutRoute,
  } as any)
const AuthenticatedNewLayoutCampaignIcpRoute =
  AuthenticatedNewLayoutCampaignIcpRouteImport.update({
    id: '/campaign/icp',
    path: '/campaign/icp',
    getParentRoute: () => AuthenticatedNewLayoutRoute,
  } as any)
const AuthenticatedNewLayoutCampaignLocationRoute =
  AuthenticatedNewLayoutCampaignLocationRouteImport.update({
    id: '/campaign/location',
    path: '/campaign/location',
    getParentRoute: () => AuthenticatedNewLayoutRoute,
  } as any)
const AuthenticatedNewLayoutCampaignMetaRoute =
  AuthenticatedNewLayoutCampaignMetaRouteImport.update({
    id: '/campaign/meta',
    path: '/campaign/meta',
    getParentRoute: () => AuthenticatedNewLayoutRoute,
  } as any)
const AuthenticatedNewLayoutCampaignProspectingRoute =
  AuthenticatedNewLayoutCampaignProspectingRouteImport.update({
    id: '/campaign/prospecting',
    path: '/campaign/prospecting',
    getParentRoute: () => AuthenticatedNewLayoutRoute,
  } as any)
const AuthenticatedNewLayoutDeployingSlugRoute =
  AuthenticatedNewLayoutDeployingSlugRouteImport.update({
    id: '/deploying/$slug',
    path: '/deploying/$slug',
    getParentRoute: () => AuthenticatedNewLayoutRoute,
  } as any)
const AuthenticatedNewLayoutOnboardingIndexRoute =
  AuthenticatedNewLayoutOnboardingIndexRouteImport.update({
    id: '/onboarding/',
    path: '/onboarding/',
    getParentRoute: () => AuthenticatedNewLayoutRoute,
  } as any)
const AuthenticatedNewLayoutOnboardingGeneratingRoute =
  AuthenticatedNewLayoutOnboardingGeneratingRouteImport.update({
    id: '/onboarding/generating',
    path: '/onboarding/generating',
    getParentRoute: () => AuthenticatedNewLayoutRoute,
  } as any)
const AuthenticatedLayoutCampaignsGoogleCampaignslugSlugRoute =
  AuthenticatedLayoutCampaignsGoogleCampaignslugSlugRouteImport.update({
    id: '/google/$campaignslug/_slug',
    path: '/google/$campaignslug',
    getParentRoute: () => AuthenticatedLayoutCampaignsRouteRoute,
  } as any)
const AuthenticatedLayoutCampaignsGoogleCampaignslugSlugIndexRoute =
  AuthenticatedLayoutCampaignsGoogleCampaignslugSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedLayoutCampaignsGoogleCampaignslugSlugRoute,
  } as any)
const AuthenticatedLayoutCampaignsMetaMetaCampaignSlugAdAdIdRoute =
  AuthenticatedLayoutCampaignsMetaMetaCampaignSlugAdAdIdRouteImport.update({
    id: '/meta/$metaCampaignSlug_/ad/$adId',
    path: '/meta/$metaCampaignSlug/ad/$adId',
    getParentRoute: () => AuthenticatedLayoutCampaignsRouteRoute,
  } as any)
const AuthenticatedLayoutCampaignsMetaMetaCampaignSlugAdsetAdSetIdRoute =
  AuthenticatedLayoutCampaignsMetaMetaCampaignSlugAdsetAdSetIdRouteImport.update(
    {
      id: '/meta/$metaCampaignSlug_/adset/$adSetId',
      path: '/meta/$metaCampaignSlug/adset/$adSetId',
      getParentRoute: () => AuthenticatedLayoutCampaignsRouteRoute,
    } as any,
  )
const AuthenticatedLayoutSettingsLayoutIntegrationsHubspotCallbackRoute =
  AuthenticatedLayoutSettingsLayoutIntegrationsHubspotCallbackRouteImport.update(
    {
      id: '/hubspot/callback',
      path: '/hubspot/callback',
      getParentRoute: () => AuthenticatedLayoutSettingsLayoutIntegrationsRoute,
    } as any,
  )
const AuthenticatedLayoutSettingsLayoutIntegrationsMetaCallbackRoute =
  AuthenticatedLayoutSettingsLayoutIntegrationsMetaCallbackRouteImport.update({
    id: '/meta/callback',
    path: '/meta/callback',
    getParentRoute: () => AuthenticatedLayoutSettingsLayoutIntegrationsRoute,
  } as any)
const AuthenticatedLayoutCampaignsGoogleCampaignslugSlugAdAdIdRoute =
  AuthenticatedLayoutCampaignsGoogleCampaignslugSlugAdAdIdRouteImport.update({
    id: '/ad/$adId',
    path: '/ad/$adId',
    getParentRoute: () =>
      AuthenticatedLayoutCampaignsGoogleCampaignslugSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedLayoutIndexRoute
  '/chart-render': typeof ChartRenderRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/signin': typeof SigninRoute
  '/signup': typeof SignupRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/add-to-campaign': typeof AuthenticatedAddToCampaignRoute
  '/impersonate': typeof AuthenticatedImpersonateRoute
  '/pending-invites': typeof AuthenticatedPendingInvitesRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/campaigns': typeof AuthenticatedLayoutCampaignsRouteRouteWithChildren
  '/performance': typeof AuthenticatedLayoutPerformanceRouteRouteWithChildren
  '/client/$slug': typeof AuthenticatedClientSlugRoute
  '/new': typeof AuthenticatedNewLayoutRouteWithChildren
  '/welcome/organization-name': typeof AuthenticatedWelcomeOrganizationNameRoute
  '/welcome/': typeof AuthenticatedWelcomeIndexRoute
  '/invite-signup/$code/': typeof InviteSignupCodeIndexRoute
  '/admin/keywords': typeof AuthenticatedLayoutAdminKeywordsRoute
  '/admin/scheduler': typeof AuthenticatedLayoutAdminSchedulerRoute
  '/business/$orgId': typeof AuthenticatedLayoutBusinessOrgIdRoute
  '/campaigns/$campaignslug': typeof AuthenticatedLayoutCampaignsCampaignslugRoute
  '/competitors/$competitorId': typeof AuthenticatedLayoutCompetitorsCompetitorIdRoute
  '/components/animations': typeof AuthenticatedLayoutComponentsAnimationsRoute
  '/components/buttons': typeof AuthenticatedLayoutComponentsButtonsRoute
  '/components/colors': typeof AuthenticatedLayoutComponentsColorsRoute
  '/components/forms': typeof AuthenticatedLayoutComponentsFormsRoute
  '/components/iconography': typeof AuthenticatedLayoutComponentsIconographyRoute
  '/components/tables': typeof AuthenticatedLayoutComponentsTablesRoute
  '/components/typography': typeof AuthenticatedLayoutComponentsTypographyRoute
  '/components/wizards': typeof AuthenticatedLayoutComponentsWizardsRoute
  '/notifications/$notificationId': typeof AuthenticatedLayoutNotificationsNotificationIdRoute
  '/organizations/$orgId': typeof AuthenticatedLayoutOrganizationsOrgIdRoute
  '/reports/$reportId': typeof AuthenticatedLayoutReportsReportIdRoute
  '/settings': typeof AuthenticatedLayoutSettingsLayoutRouteWithChildren
  '/tasks': typeof AuthenticatedLayoutTasksLayoutRouteWithChildren
  '/new/brand': typeof AuthenticatedNewLayoutBrandRoute
  '/admin/': typeof AuthenticatedLayoutAdminIndexRoute
  '/assets/': typeof AuthenticatedLayoutAssetsIndexRoute
  '/business/': typeof AuthenticatedLayoutBusinessIndexRoute
  '/campaigns/': typeof AuthenticatedLayoutCampaignsIndexRoute
  '/competitors/': typeof AuthenticatedLayoutCompetitorsIndexRoute
  '/components/': typeof AuthenticatedLayoutComponentsIndexRoute
  '/meta-campaigns/': typeof AuthenticatedLayoutMetaCampaignsIndexRoute
  '/notifications/': typeof AuthenticatedLayoutNotificationsIndexRoute
  '/optimizations/': typeof AuthenticatedLayoutOptimizationsIndexRoute
  '/organizations/': typeof AuthenticatedLayoutOrganizationsIndexRoute
  '/performance-beta/': typeof AuthenticatedLayoutPerformanceBetaIndexRoute
  '/performance-consolidated/': typeof AuthenticatedLayoutPerformanceConsolidatedIndexRoute
  '/performance/': typeof AuthenticatedLayoutPerformanceIndexRoute
  '/reports/': typeof AuthenticatedLayoutReportsIndexRoute
  '/settings/': typeof AuthenticatedLayoutSettingsIndexRoute
  '/setup/': typeof AuthenticatedLayoutSetupIndexRoute
  '/strategy/': typeof AuthenticatedLayoutStrategyIndexRoute
  '/tasks/': typeof AuthenticatedLayoutTasksIndexRoute
  '/campaigns/meta/$metaCampaignSlug': typeof AuthenticatedLayoutCampaignsMetaMetaCampaignSlugRoute
  '/settings/account': typeof AuthenticatedLayoutSettingsLayoutAccountRoute
  '/settings/billing': typeof AuthenticatedLayoutSettingsLayoutBillingRoute
  '/settings/budget': typeof AuthenticatedLayoutSettingsLayoutBudgetRoute
  '/settings/company': typeof AuthenticatedLayoutSettingsLayoutCompanyRoute
  '/settings/conversions': typeof AuthenticatedLayoutSettingsLayoutConversionsRoute
  '/settings/integrations': typeof AuthenticatedLayoutSettingsLayoutIntegrationsRouteWithChildren
  '/settings/notification': typeof AuthenticatedLayoutSettingsLayoutNotificationRoute
  '/settings/reports': typeof AuthenticatedLayoutSettingsLayoutReportsRoute
  '/settings/team': typeof AuthenticatedLayoutSettingsLayoutTeamRoute
  '/tasks/negative-keywords': typeof AuthenticatedLayoutTasksLayoutNegativeKeywordsRoute
  '/tasks/new': typeof AuthenticatedLayoutTasksLayoutNewRoute
  '/tasks/recommendations': typeof AuthenticatedLayoutTasksLayoutRecommendationsRoute
  '/new/$campaignslug/generating': typeof AuthenticatedNewLayoutCampaignslugGeneratingRoute
  '/new/campaign/brand': typeof AuthenticatedNewLayoutCampaignBrandRoute
  '/new/campaign/competitor': typeof AuthenticatedNewLayoutCampaignCompetitorRoute
  '/new/campaign/hipo': typeof AuthenticatedNewLayoutCampaignHipoRoute
  '/new/campaign/icp': typeof AuthenticatedNewLayoutCampaignIcpRoute
  '/new/campaign/location': typeof AuthenticatedNewLayoutCampaignLocationRoute
  '/new/campaign/meta': typeof AuthenticatedNewLayoutCampaignMetaRoute
  '/new/campaign/prospecting': typeof AuthenticatedNewLayoutCampaignProspectingRoute
  '/new/deploying/$slug': typeof AuthenticatedNewLayoutDeployingSlugRoute
  '/new/onboarding/generating': typeof AuthenticatedNewLayoutOnboardingGeneratingRoute
  '/performance/$campaignSlug/': typeof AuthenticatedLayoutPerformanceCampaignSlugIndexRoute
  '/new/campaign/': typeof AuthenticatedNewLayoutCampaignIndexRoute
  '/new/onboarding/': typeof AuthenticatedNewLayoutOnboardingIndexRoute
  '/campaigns/google/$campaignslug': typeof AuthenticatedLayoutCampaignsGoogleCampaignslugSlugRouteWithChildren
  '/campaigns/meta/$metaCampaignSlug/ad/$adId': typeof AuthenticatedLayoutCampaignsMetaMetaCampaignSlugAdAdIdRoute
  '/campaigns/meta/$metaCampaignSlug/adset/$adSetId': typeof AuthenticatedLayoutCampaignsMetaMetaCampaignSlugAdsetAdSetIdRoute
  '/settings/integrations/hubspot/callback': typeof AuthenticatedLayoutSettingsLayoutIntegrationsHubspotCallbackRoute
  '/settings/integrations/meta/callback': typeof AuthenticatedLayoutSettingsLayoutIntegrationsMetaCallbackRoute
  '/campaigns/google/$campaignslug/': typeof AuthenticatedLayoutCampaignsGoogleCampaignslugSlugIndexRoute
  '/campaigns/google/$campaignslug/ad/$adId': typeof AuthenticatedLayoutCampaignsGoogleCampaignslugSlugAdAdIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedLayoutIndexRoute
  '/chart-render': typeof ChartRenderRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/signin': typeof SigninRoute
  '/signup': typeof SignupRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/add-to-campaign': typeof AuthenticatedAddToCampaignRoute
  '/impersonate': typeof AuthenticatedImpersonateRoute
  '/pending-invites': typeof AuthenticatedPendingInvitesRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/client/$slug': typeof AuthenticatedClientSlugRoute
  '/new': typeof AuthenticatedNewLayoutRouteWithChildren
  '/welcome/organization-name': typeof AuthenticatedWelcomeOrganizationNameRoute
  '/welcome': typeof AuthenticatedWelcomeIndexRoute
  '/invite-signup/$code': typeof InviteSignupCodeIndexRoute
  '/admin/keywords': typeof AuthenticatedLayoutAdminKeywordsRoute
  '/admin/scheduler': typeof AuthenticatedLayoutAdminSchedulerRoute
  '/business/$orgId': typeof AuthenticatedLayoutBusinessOrgIdRoute
  '/campaigns/$campaignslug': typeof AuthenticatedLayoutCampaignsCampaignslugRoute
  '/competitors/$competitorId': typeof AuthenticatedLayoutCompetitorsCompetitorIdRoute
  '/components/animations': typeof AuthenticatedLayoutComponentsAnimationsRoute
  '/components/buttons': typeof AuthenticatedLayoutComponentsButtonsRoute
  '/components/colors': typeof AuthenticatedLayoutComponentsColorsRoute
  '/components/forms': typeof AuthenticatedLayoutComponentsFormsRoute
  '/components/iconography': typeof AuthenticatedLayoutComponentsIconographyRoute
  '/components/tables': typeof AuthenticatedLayoutComponentsTablesRoute
  '/components/typography': typeof AuthenticatedLayoutComponentsTypographyRoute
  '/components/wizards': typeof AuthenticatedLayoutComponentsWizardsRoute
  '/notifications/$notificationId': typeof AuthenticatedLayoutNotificationsNotificationIdRoute
  '/organizations/$orgId': typeof AuthenticatedLayoutOrganizationsOrgIdRoute
  '/reports/$reportId': typeof AuthenticatedLayoutReportsReportIdRoute
  '/settings': typeof AuthenticatedLayoutSettingsIndexRoute
  '/tasks': typeof AuthenticatedLayoutTasksIndexRoute
  '/new/brand': typeof AuthenticatedNewLayoutBrandRoute
  '/admin': typeof AuthenticatedLayoutAdminIndexRoute
  '/assets': typeof AuthenticatedLayoutAssetsIndexRoute
  '/business': typeof AuthenticatedLayoutBusinessIndexRoute
  '/campaigns': typeof AuthenticatedLayoutCampaignsIndexRoute
  '/competitors': typeof AuthenticatedLayoutCompetitorsIndexRoute
  '/components': typeof AuthenticatedLayoutComponentsIndexRoute
  '/meta-campaigns': typeof AuthenticatedLayoutMetaCampaignsIndexRoute
  '/notifications': typeof AuthenticatedLayoutNotificationsIndexRoute
  '/optimizations': typeof AuthenticatedLayoutOptimizationsIndexRoute
  '/organizations': typeof AuthenticatedLayoutOrganizationsIndexRoute
  '/performance-beta': typeof AuthenticatedLayoutPerformanceBetaIndexRoute
  '/performance-consolidated': typeof AuthenticatedLayoutPerformanceConsolidatedIndexRoute
  '/performance': typeof AuthenticatedLayoutPerformanceIndexRoute
  '/reports': typeof AuthenticatedLayoutReportsIndexRoute
  '/setup': typeof AuthenticatedLayoutSetupIndexRoute
  '/strategy': typeof AuthenticatedLayoutStrategyIndexRoute
  '/campaigns/meta/$metaCampaignSlug': typeof AuthenticatedLayoutCampaignsMetaMetaCampaignSlugRoute
  '/settings/account': typeof AuthenticatedLayoutSettingsLayoutAccountRoute
  '/settings/billing': typeof AuthenticatedLayoutSettingsLayoutBillingRoute
  '/settings/budget': typeof AuthenticatedLayoutSettingsLayoutBudgetRoute
  '/settings/company': typeof AuthenticatedLayoutSettingsLayoutCompanyRoute
  '/settings/conversions': typeof AuthenticatedLayoutSettingsLayoutConversionsRoute
  '/settings/integrations': typeof AuthenticatedLayoutSettingsLayoutIntegrationsRouteWithChildren
  '/settings/notification': typeof AuthenticatedLayoutSettingsLayoutNotificationRoute
  '/settings/reports': typeof AuthenticatedLayoutSettingsLayoutReportsRoute
  '/settings/team': typeof AuthenticatedLayoutSettingsLayoutTeamRoute
  '/tasks/negative-keywords': typeof AuthenticatedLayoutTasksLayoutNegativeKeywordsRoute
  '/tasks/new': typeof AuthenticatedLayoutTasksLayoutNewRoute
  '/tasks/recommendations': typeof AuthenticatedLayoutTasksLayoutRecommendationsRoute
  '/new/$campaignslug/generating': typeof AuthenticatedNewLayoutCampaignslugGeneratingRoute
  '/new/campaign/brand': typeof AuthenticatedNewLayoutCampaignBrandRoute
  '/new/campaign/competitor': typeof AuthenticatedNewLayoutCampaignCompetitorRoute
  '/new/campaign/hipo': typeof AuthenticatedNewLayoutCampaignHipoRoute
  '/new/campaign/icp': typeof AuthenticatedNewLayoutCampaignIcpRoute
  '/new/campaign/location': typeof AuthenticatedNewLayoutCampaignLocationRoute
  '/new/campaign/meta': typeof AuthenticatedNewLayoutCampaignMetaRoute
  '/new/campaign/prospecting': typeof AuthenticatedNewLayoutCampaignProspectingRoute
  '/new/deploying/$slug': typeof AuthenticatedNewLayoutDeployingSlugRoute
  '/new/onboarding/generating': typeof AuthenticatedNewLayoutOnboardingGeneratingRoute
  '/performance/$campaignSlug': typeof AuthenticatedLayoutPerformanceCampaignSlugIndexRoute
  '/new/campaign': typeof AuthenticatedNewLayoutCampaignIndexRoute
  '/new/onboarding': typeof AuthenticatedNewLayoutOnboardingIndexRoute
  '/campaigns/meta/$metaCampaignSlug/ad/$adId': typeof AuthenticatedLayoutCampaignsMetaMetaCampaignSlugAdAdIdRoute
  '/campaigns/meta/$metaCampaignSlug/adset/$adSetId': typeof AuthenticatedLayoutCampaignsMetaMetaCampaignSlugAdsetAdSetIdRoute
  '/settings/integrations/hubspot/callback': typeof AuthenticatedLayoutSettingsLayoutIntegrationsHubspotCallbackRoute
  '/settings/integrations/meta/callback': typeof AuthenticatedLayoutSettingsLayoutIntegrationsMetaCallbackRoute
  '/campaigns/google/$campaignslug': typeof AuthenticatedLayoutCampaignsGoogleCampaignslugSlugIndexRoute
  '/campaigns/google/$campaignslug/ad/$adId': typeof AuthenticatedLayoutCampaignsGoogleCampaignslugSlugAdAdIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/chart-render': typeof ChartRenderRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/signin': typeof SigninRoute
  '/signup': typeof SignupRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/_authenticated/_layout': typeof AuthenticatedLayoutRouteWithChildren
  '/_authenticated/add-to-campaign': typeof AuthenticatedAddToCampaignRoute
  '/_authenticated/impersonate': typeof AuthenticatedImpersonateRoute
  '/_authenticated/pending-invites': typeof AuthenticatedPendingInvitesRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/_authenticated/_layout/campaigns': typeof AuthenticatedLayoutCampaignsRouteRouteWithChildren
  '/_authenticated/_layout/performance': typeof AuthenticatedLayoutPerformanceRouteRouteWithChildren
  '/_authenticated/client/$slug': typeof AuthenticatedClientSlugRoute
  '/_authenticated/new/_layout': typeof AuthenticatedNewLayoutRouteWithChildren
  '/_authenticated/welcome/organization-name': typeof AuthenticatedWelcomeOrganizationNameRoute
  '/_authenticated/_layout/': typeof AuthenticatedLayoutIndexRoute
  '/_authenticated/welcome/': typeof AuthenticatedWelcomeIndexRoute
  '/invite-signup/$code/': typeof InviteSignupCodeIndexRoute
  '/_authenticated/_layout/admin/keywords': typeof AuthenticatedLayoutAdminKeywordsRoute
  '/_authenticated/_layout/admin/scheduler': typeof AuthenticatedLayoutAdminSchedulerRoute
  '/_authenticated/_layout/business/$orgId': typeof AuthenticatedLayoutBusinessOrgIdRoute
  '/_authenticated/_layout/campaigns/$campaignslug': typeof AuthenticatedLayoutCampaignsCampaignslugRoute
  '/_authenticated/_layout/competitors/$competitorId': typeof AuthenticatedLayoutCompetitorsCompetitorIdRoute
  '/_authenticated/_layout/components/animations': typeof AuthenticatedLayoutComponentsAnimationsRoute
  '/_authenticated/_layout/components/buttons': typeof AuthenticatedLayoutComponentsButtonsRoute
  '/_authenticated/_layout/components/colors': typeof AuthenticatedLayoutComponentsColorsRoute
  '/_authenticated/_layout/components/forms': typeof AuthenticatedLayoutComponentsFormsRoute
  '/_authenticated/_layout/components/iconography': typeof AuthenticatedLayoutComponentsIconographyRoute
  '/_authenticated/_layout/components/tables': typeof AuthenticatedLayoutComponentsTablesRoute
  '/_authenticated/_layout/components/typography': typeof AuthenticatedLayoutComponentsTypographyRoute
  '/_authenticated/_layout/components/wizards': typeof AuthenticatedLayoutComponentsWizardsRoute
  '/_authenticated/_layout/notifications/$notificationId': typeof AuthenticatedLayoutNotificationsNotificationIdRoute
  '/_authenticated/_layout/organizations/$orgId': typeof AuthenticatedLayoutOrganizationsOrgIdRoute
  '/_authenticated/_layout/reports/$reportId': typeof AuthenticatedLayoutReportsReportIdRoute
  '/_authenticated/_layout/settings/_layout': typeof AuthenticatedLayoutSettingsLayoutRouteWithChildren
  '/_authenticated/_layout/tasks/_layout': typeof AuthenticatedLayoutTasksLayoutRouteWithChildren
  '/_authenticated/new/_layout/brand': typeof AuthenticatedNewLayoutBrandRoute
  '/_authenticated/_layout/admin/': typeof AuthenticatedLayoutAdminIndexRoute
  '/_authenticated/_layout/assets/': typeof AuthenticatedLayoutAssetsIndexRoute
  '/_authenticated/_layout/business/': typeof AuthenticatedLayoutBusinessIndexRoute
  '/_authenticated/_layout/campaigns/': typeof AuthenticatedLayoutCampaignsIndexRoute
  '/_authenticated/_layout/competitors/': typeof AuthenticatedLayoutCompetitorsIndexRoute
  '/_authenticated/_layout/components/': typeof AuthenticatedLayoutComponentsIndexRoute
  '/_authenticated/_layout/meta-campaigns/': typeof AuthenticatedLayoutMetaCampaignsIndexRoute
  '/_authenticated/_layout/notifications/': typeof AuthenticatedLayoutNotificationsIndexRoute
  '/_authenticated/_layout/optimizations/': typeof AuthenticatedLayoutOptimizationsIndexRoute
  '/_authenticated/_layout/organizations/': typeof AuthenticatedLayoutOrganizationsIndexRoute
  '/_authenticated/_layout/performance-beta/': typeof AuthenticatedLayoutPerformanceBetaIndexRoute
  '/_authenticated/_layout/performance-consolidated/': typeof AuthenticatedLayoutPerformanceConsolidatedIndexRoute
  '/_authenticated/_layout/performance/': typeof AuthenticatedLayoutPerformanceIndexRoute
  '/_authenticated/_layout/reports/': typeof AuthenticatedLayoutReportsIndexRoute
  '/_authenticated/_layout/settings/': typeof AuthenticatedLayoutSettingsIndexRoute
  '/_authenticated/_layout/setup/': typeof AuthenticatedLayoutSetupIndexRoute
  '/_authenticated/_layout/strategy/': typeof AuthenticatedLayoutStrategyIndexRoute
  '/_authenticated/_layout/tasks/': typeof AuthenticatedLayoutTasksIndexRoute
  '/_authenticated/_layout/campaigns/meta/$metaCampaignSlug': typeof AuthenticatedLayoutCampaignsMetaMetaCampaignSlugRoute
  '/_authenticated/_layout/settings/_layout/account': typeof AuthenticatedLayoutSettingsLayoutAccountRoute
  '/_authenticated/_layout/settings/_layout/billing': typeof AuthenticatedLayoutSettingsLayoutBillingRoute
  '/_authenticated/_layout/settings/_layout/budget': typeof AuthenticatedLayoutSettingsLayoutBudgetRoute
  '/_authenticated/_layout/settings/_layout/company': typeof AuthenticatedLayoutSettingsLayoutCompanyRoute
  '/_authenticated/_layout/settings/_layout/conversions': typeof AuthenticatedLayoutSettingsLayoutConversionsRoute
  '/_authenticated/_layout/settings/_layout/integrations': typeof AuthenticatedLayoutSettingsLayoutIntegrationsRouteWithChildren
  '/_authenticated/_layout/settings/_layout/notification': typeof AuthenticatedLayoutSettingsLayoutNotificationRoute
  '/_authenticated/_layout/settings/_layout/reports': typeof AuthenticatedLayoutSettingsLayoutReportsRoute
  '/_authenticated/_layout/settings/_layout/team': typeof AuthenticatedLayoutSettingsLayoutTeamRoute
  '/_authenticated/_layout/tasks/_layout/negative-keywords': typeof AuthenticatedLayoutTasksLayoutNegativeKeywordsRoute
  '/_authenticated/_layout/tasks/_layout/new': typeof AuthenticatedLayoutTasksLayoutNewRoute
  '/_authenticated/_layout/tasks/_layout/recommendations': typeof AuthenticatedLayoutTasksLayoutRecommendationsRoute
  '/_authenticated/new/_layout/$campaignslug/generating': typeof AuthenticatedNewLayoutCampaignslugGeneratingRoute
  '/_authenticated/new/_layout/campaign/brand': typeof AuthenticatedNewLayoutCampaignBrandRoute
  '/_authenticated/new/_layout/campaign/competitor': typeof AuthenticatedNewLayoutCampaignCompetitorRoute
  '/_authenticated/new/_layout/campaign/hipo': typeof AuthenticatedNewLayoutCampaignHipoRoute
  '/_authenticated/new/_layout/campaign/icp': typeof AuthenticatedNewLayoutCampaignIcpRoute
  '/_authenticated/new/_layout/campaign/location': typeof AuthenticatedNewLayoutCampaignLocationRoute
  '/_authenticated/new/_layout/campaign/meta': typeof AuthenticatedNewLayoutCampaignMetaRoute
  '/_authenticated/new/_layout/campaign/prospecting': typeof AuthenticatedNewLayoutCampaignProspectingRoute
  '/_authenticated/new/_layout/deploying/$slug': typeof AuthenticatedNewLayoutDeployingSlugRoute
  '/_authenticated/new/_layout/onboarding/generating': typeof AuthenticatedNewLayoutOnboardingGeneratingRoute
  '/_authenticated/_layout/performance/$campaignSlug/': typeof AuthenticatedLayoutPerformanceCampaignSlugIndexRoute
  '/_authenticated/new/_layout/campaign/': typeof AuthenticatedNewLayoutCampaignIndexRoute
  '/_authenticated/new/_layout/onboarding/': typeof AuthenticatedNewLayoutOnboardingIndexRoute
  '/_authenticated/_layout/campaigns/google/$campaignslug/_slug': typeof AuthenticatedLayoutCampaignsGoogleCampaignslugSlugRouteWithChildren
  '/_authenticated/_layout/campaigns/meta/$metaCampaignSlug_/ad/$adId': typeof AuthenticatedLayoutCampaignsMetaMetaCampaignSlugAdAdIdRoute
  '/_authenticated/_layout/campaigns/meta/$metaCampaignSlug_/adset/$adSetId': typeof AuthenticatedLayoutCampaignsMetaMetaCampaignSlugAdsetAdSetIdRoute
  '/_authenticated/_layout/settings/_layout/integrations/hubspot/callback': typeof AuthenticatedLayoutSettingsLayoutIntegrationsHubspotCallbackRoute
  '/_authenticated/_layout/settings/_layout/integrations/meta/callback': typeof AuthenticatedLayoutSettingsLayoutIntegrationsMetaCallbackRoute
  '/_authenticated/_layout/campaigns/google/$campaignslug/_slug/': typeof AuthenticatedLayoutCampaignsGoogleCampaignslugSlugIndexRoute
  '/_authenticated/_layout/campaigns/google/$campaignslug/_slug/ad/$adId': typeof AuthenticatedLayoutCampaignsGoogleCampaignslugSlugAdAdIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/chart-render'
    | '/forgot-password'
    | '/login'
    | '/signin'
    | '/signup'
    | '/unsubscribe'
    | '/add-to-campaign'
    | '/impersonate'
    | '/pending-invites'
    | '/oauth/consent'
    | '/reset-password/$token'
    | '/campaigns'
    | '/performance'
    | '/client/$slug'
    | '/new'
    | '/welcome/organization-name'
    | '/welcome/'
    | '/invite-signup/$code/'
    | '/admin/keywords'
    | '/admin/scheduler'
    | '/business/$orgId'
    | '/campaigns/$campaignslug'
    | '/competitors/$competitorId'
    | '/components/animations'
    | '/components/buttons'
    | '/components/colors'
    | '/components/forms'
    | '/components/iconography'
    | '/components/tables'
    | '/components/typography'
    | '/components/wizards'
    | '/notifications/$notificationId'
    | '/organizations/$orgId'
    | '/reports/$reportId'
    | '/settings'
    | '/tasks'
    | '/new/brand'
    | '/admin/'
    | '/assets/'
    | '/business/'
    | '/campaigns/'
    | '/competitors/'
    | '/components/'
    | '/meta-campaigns/'
    | '/notifications/'
    | '/optimizations/'
    | '/organizations/'
    | '/performance-beta/'
    | '/performance-consolidated/'
    | '/performance/'
    | '/reports/'
    | '/settings/'
    | '/setup/'
    | '/strategy/'
    | '/tasks/'
    | '/campaigns/meta/$metaCampaignSlug'
    | '/settings/account'
    | '/settings/billing'
    | '/settings/budget'
    | '/settings/company'
    | '/settings/conversions'
    | '/settings/integrations'
    | '/settings/notification'
    | '/settings/reports'
    | '/settings/team'
    | '/tasks/negative-keywords'
    | '/tasks/new'
    | '/tasks/recommendations'
    | '/new/$campaignslug/generating'
    | '/new/campaign/brand'
    | '/new/campaign/competitor'
    | '/new/campaign/hipo'
    | '/new/campaign/icp'
    | '/new/campaign/location'
    | '/new/campaign/meta'
    | '/new/campaign/prospecting'
    | '/new/deploying/$slug'
    | '/new/onboarding/generating'
    | '/performance/$campaignSlug/'
    | '/new/campaign/'
    | '/new/onboarding/'
    | '/campaigns/google/$campaignslug'
    | '/campaigns/meta/$metaCampaignSlug/ad/$adId'
    | '/campaigns/meta/$metaCampaignSlug/adset/$adSetId'
    | '/settings/integrations/hubspot/callback'
    | '/settings/integrations/meta/callback'
    | '/campaigns/google/$campaignslug/'
    | '/campaigns/google/$campaignslug/ad/$adId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/chart-render'
    | '/forgot-password'
    | '/login'
    | '/signin'
    | '/signup'
    | '/unsubscribe'
    | '/add-to-campaign'
    | '/impersonate'
    | '/pending-invites'
    | '/oauth/consent'
    | '/reset-password/$token'
    | '/client/$slug'
    | '/new'
    | '/welcome/organization-name'
    | '/welcome'
    | '/invite-signup/$code'
    | '/admin/keywords'
    | '/admin/scheduler'
    | '/business/$orgId'
    | '/campaigns/$campaignslug'
    | '/competitors/$competitorId'
    | '/components/animations'
    | '/components/buttons'
    | '/components/colors'
    | '/components/forms'
    | '/components/iconography'
    | '/components/tables'
    | '/components/typography'
    | '/components/wizards'
    | '/notifications/$notificationId'
    | '/organizations/$orgId'
    | '/reports/$reportId'
    | '/settings'
    | '/tasks'
    | '/new/brand'
    | '/admin'
    | '/assets'
    | '/business'
    | '/campaigns'
    | '/competitors'
    | '/components'
    | '/meta-campaigns'
    | '/notifications'
    | '/optimizations'
    | '/organizations'
    | '/performance-beta'
    | '/performance-consolidated'
    | '/performance'
    | '/reports'
    | '/setup'
    | '/strategy'
    | '/campaigns/meta/$metaCampaignSlug'
    | '/settings/account'
    | '/settings/billing'
    | '/settings/budget'
    | '/settings/company'
    | '/settings/conversions'
    | '/settings/integrations'
    | '/settings/notification'
    | '/settings/reports'
    | '/settings/team'
    | '/tasks/negative-keywords'
    | '/tasks/new'
    | '/tasks/recommendations'
    | '/new/$campaignslug/generating'
    | '/new/campaign/brand'
    | '/new/campaign/competitor'
    | '/new/campaign/hipo'
    | '/new/campaign/icp'
    | '/new/campaign/location'
    | '/new/campaign/meta'
    | '/new/campaign/prospecting'
    | '/new/deploying/$slug'
    | '/new/onboarding/generating'
    | '/performance/$campaignSlug'
    | '/new/campaign'
    | '/new/onboarding'
    | '/campaigns/meta/$metaCampaignSlug/ad/$adId'
    | '/campaigns/meta/$metaCampaignSlug/adset/$adSetId'
    | '/settings/integrations/hubspot/callback'
    | '/settings/integrations/meta/callback'
    | '/campaigns/google/$campaignslug'
    | '/campaigns/google/$campaignslug/ad/$adId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/chart-render'
    | '/forgot-password'
    | '/login'
    | '/signin'
    | '/signup'
    | '/unsubscribe'
    | '/_authenticated/_layout'
    | '/_authenticated/add-to-campaign'
    | '/_authenticated/impersonate'
    | '/_authenticated/pending-invites'
    | '/oauth/consent'
    | '/reset-password/$token'
    | '/_authenticated/_layout/campaigns'
    | '/_authenticated/_layout/performance'
    | '/_authenticated/client/$slug'
    | '/_authenticated/new/_layout'
    | '/_authenticated/welcome/organization-name'
    | '/_authenticated/_layout/'
    | '/_authenticated/welcome/'
    | '/invite-signup/$code/'
    | '/_authenticated/_layout/admin/keywords'
    | '/_authenticated/_layout/admin/scheduler'
    | '/_authenticated/_layout/business/$orgId'
    | '/_authenticated/_layout/campaigns/$campaignslug'
    | '/_authenticated/_layout/competitors/$competitorId'
    | '/_authenticated/_layout/components/animations'
    | '/_authenticated/_layout/components/buttons'
    | '/_authenticated/_layout/components/colors'
    | '/_authenticated/_layout/components/forms'
    | '/_authenticated/_layout/components/iconography'
    | '/_authenticated/_layout/components/tables'
    | '/_authenticated/_layout/components/typography'
    | '/_authenticated/_layout/components/wizards'
    | '/_authenticated/_layout/notifications/$notificationId'
    | '/_authenticated/_layout/organizations/$orgId'
    | '/_authenticated/_layout/reports/$reportId'
    | '/_authenticated/_layout/settings/_layout'
    | '/_authenticated/_layout/tasks/_layout'
    | '/_authenticated/new/_layout/brand'
    | '/_authenticated/_layout/admin/'
    | '/_authenticated/_layout/assets/'
    | '/_authenticated/_layout/business/'
    | '/_authenticated/_layout/campaigns/'
    | '/_authenticated/_layout/competitors/'
    | '/_authenticated/_layout/components/'
    | '/_authenticated/_layout/meta-campaigns/'
    | '/_authenticated/_layout/notifications/'
    | '/_authenticated/_layout/optimizations/'
    | '/_authenticated/_layout/organizations/'
    | '/_authenticated/_layout/performance-beta/'
    | '/_authenticated/_layout/performance-consolidated/'
    | '/_authenticated/_layout/performance/'
    | '/_authenticated/_layout/reports/'
    | '/_authenticated/_layout/settings/'
    | '/_authenticated/_layout/setup/'
    | '/_authenticated/_layout/strategy/'
    | '/_authenticated/_layout/tasks/'
    | '/_authenticated/_layout/campaigns/meta/$metaCampaignSlug'
    | '/_authenticated/_layout/settings/_layout/account'
    | '/_authenticated/_layout/settings/_layout/billing'
    | '/_authenticated/_layout/settings/_layout/budget'
    | '/_authenticated/_layout/settings/_layout/company'
    | '/_authenticated/_layout/settings/_layout/conversions'
    | '/_authenticated/_layout/settings/_layout/integrations'
    | '/_authenticated/_layout/settings/_layout/notification'
    | '/_authenticated/_layout/settings/_layout/reports'
    | '/_authenticated/_layout/settings/_layout/team'
    | '/_authenticated/_layout/tasks/_layout/negative-keywords'
    | '/_authenticated/_layout/tasks/_layout/new'
    | '/_authenticated/_layout/tasks/_layout/recommendations'
    | '/_authenticated/new/_layout/$campaignslug/generating'
    | '/_authenticated/new/_layout/campaign/brand'
    | '/_authenticated/new/_layout/campaign/competitor'
    | '/_authenticated/new/_layout/campaign/hipo'
    | '/_authenticated/new/_layout/campaign/icp'
    | '/_authenticated/new/_layout/campaign/location'
    | '/_authenticated/new/_layout/campaign/meta'
    | '/_authenticated/new/_layout/campaign/prospecting'
    | '/_authenticated/new/_layout/deploying/$slug'
    | '/_authenticated/new/_layout/onboarding/generating'
    | '/_authenticated/_layout/performance/$campaignSlug/'
    | '/_authenticated/new/_layout/campaign/'
    | '/_authenticated/new/_layout/onboarding/'
    | '/_authenticated/_layout/campaigns/google/$campaignslug/_slug'
    | '/_authenticated/_layout/campaigns/meta/$metaCampaignSlug_/ad/$adId'
    | '/_authenticated/_layout/campaigns/meta/$metaCampaignSlug_/adset/$adSetId'
    | '/_authenticated/_layout/settings/_layout/integrations/hubspot/callback'
    | '/_authenticated/_layout/settings/_layout/integrations/meta/callback'
    | '/_authenticated/_layout/campaigns/google/$campaignslug/_slug/'
    | '/_authenticated/_layout/campaigns/google/$campaignslug/_slug/ad/$adId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ChartRenderRoute: typeof ChartRenderRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  SigninRoute: typeof SigninRoute
  SignupRoute: typeof SignupRoute
  UnsubscribeRoute: typeof UnsubscribeRoute
  OauthConsentRoute: typeof OauthConsentRoute
  ResetPasswordTokenRoute: typeof ResetPasswordTokenRoute
  InviteSignupCodeIndexRoute: typeof InviteSignupCodeIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chart-render': {
      id: '/chart-render'
      path: '/chart-render'
      fullPath: '/chart-render'
      preLoaderRoute: typeof ChartRenderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unsubscribe': {
      id: '/unsubscribe'
      path: '/unsubscribe'
      fullPath: '/unsubscribe'
      preLoaderRoute: typeof UnsubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_layout': {
      id: '/_authenticated/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedLayoutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/add-to-campaign': {
      id: '/_authenticated/add-to-campaign'
      path: '/add-to-campaign'
      fullPath: '/add-to-campaign'
      preLoaderRoute: typeof AuthenticatedAddToCampaignRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/impersonate': {
      id: '/_authenticated/impersonate'
      path: '/impersonate'
      fullPath: '/impersonate'
      preLoaderRoute: typeof AuthenticatedImpersonateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pending-invites': {
      id: '/_authenticated/pending-invites'
      path: '/pending-invites'
      fullPath: '/pending-invites'
      preLoaderRoute: typeof AuthenticatedPendingInvitesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/$token': {
      id: '/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof ResetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_layout/': {
      id: '/_authenticated/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/campaigns': {
      id: '/_authenticated/_layout/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof AuthenticatedLayoutCampaignsRouteRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/performance': {
      id: '/_authenticated/_layout/performance'
      path: '/performance'
      fullPath: '/performance'
      preLoaderRoute: typeof AuthenticatedLayoutPerformanceRouteRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/client/$slug': {
      id: '/_authenticated/client/$slug'
      path: '/client/$slug'
      fullPath: '/client/$slug'
      preLoaderRoute: typeof AuthenticatedClientSlugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/new/_layout': {
      id: '/_authenticated/new/_layout'
      path: '/new'
      fullPath: '/new'
      preLoaderRoute: typeof AuthenticatedNewLayoutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/welcome/': {
      id: '/_authenticated/welcome/'
      path: '/welcome'
      fullPath: '/welcome/'
      preLoaderRoute: typeof AuthenticatedWelcomeIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/welcome/organization-name': {
      id: '/_authenticated/welcome/organization-name'
      path: '/welcome/organization-name'
      fullPath: '/welcome/organization-name'
      preLoaderRoute: typeof AuthenticatedWelcomeOrganizationNameRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/invite-signup/$code/': {
      id: '/invite-signup/$code/'
      path: '/invite-signup/$code'
      fullPath: '/invite-signup/$code/'
      preLoaderRoute: typeof InviteSignupCodeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_layout/admin/': {
      id: '/_authenticated/_layout/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedLayoutAdminIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/admin/keywords': {
      id: '/_authenticated/_layout/admin/keywords'
      path: '/admin/keywords'
      fullPath: '/admin/keywords'
      preLoaderRoute: typeof AuthenticatedLayoutAdminKeywordsRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/admin/scheduler': {
      id: '/_authenticated/_layout/admin/scheduler'
      path: '/admin/scheduler'
      fullPath: '/admin/scheduler'
      preLoaderRoute: typeof AuthenticatedLayoutAdminSchedulerRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/assets/': {
      id: '/_authenticated/_layout/assets/'
      path: '/assets'
      fullPath: '/assets/'
      preLoaderRoute: typeof AuthenticatedLayoutAssetsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/business/': {
      id: '/_authenticated/_layout/business/'
      path: '/business'
      fullPath: '/business/'
      preLoaderRoute: typeof AuthenticatedLayoutBusinessIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/business/$orgId': {
      id: '/_authenticated/_layout/business/$orgId'
      path: '/business/$orgId'
      fullPath: '/business/$orgId'
      preLoaderRoute: typeof AuthenticatedLayoutBusinessOrgIdRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/campaigns/': {
      id: '/_authenticated/_layout/campaigns/'
      path: '/'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof AuthenticatedLayoutCampaignsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutCampaignsRouteRoute
    }
    '/_authenticated/_layout/campaigns/$campaignslug': {
      id: '/_authenticated/_layout/campaigns/$campaignslug'
      path: '/$campaignslug'
      fullPath: '/campaigns/$campaignslug'
      preLoaderRoute: typeof AuthenticatedLayoutCampaignsCampaignslugRouteImport
      parentRoute: typeof AuthenticatedLayoutCampaignsRouteRoute
    }
    '/_authenticated/_layout/competitors/': {
      id: '/_authenticated/_layout/competitors/'
      path: '/competitors'
      fullPath: '/competitors/'
      preLoaderRoute: typeof AuthenticatedLayoutCompetitorsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/competitors/$competitorId': {
      id: '/_authenticated/_layout/competitors/$competitorId'
      path: '/competitors/$competitorId'
      fullPath: '/competitors/$competitorId'
      preLoaderRoute: typeof AuthenticatedLayoutCompetitorsCompetitorIdRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/components/': {
      id: '/_authenticated/_layout/components/'
      path: '/components'
      fullPath: '/components/'
      preLoaderRoute: typeof AuthenticatedLayoutComponentsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/components/animations': {
      id: '/_authenticated/_layout/components/animations'
      path: '/components/animations'
      fullPath: '/components/animations'
      preLoaderRoute: typeof AuthenticatedLayoutComponentsAnimationsRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/components/buttons': {
      id: '/_authenticated/_layout/components/buttons'
      path: '/components/buttons'
      fullPath: '/components/buttons'
      preLoaderRoute: typeof AuthenticatedLayoutComponentsButtonsRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/components/colors': {
      id: '/_authenticated/_layout/components/colors'
      path: '/components/colors'
      fullPath: '/components/colors'
      preLoaderRoute: typeof AuthenticatedLayoutComponentsColorsRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/components/forms': {
      id: '/_authenticated/_layout/components/forms'
      path: '/components/forms'
      fullPath: '/components/forms'
      preLoaderRoute: typeof AuthenticatedLayoutComponentsFormsRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/components/iconography': {
      id: '/_authenticated/_layout/components/iconography'
      path: '/components/iconography'
      fullPath: '/components/iconography'
      preLoaderRoute: typeof AuthenticatedLayoutComponentsIconographyRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/components/tables': {
      id: '/_authenticated/_layout/components/tables'
      path: '/components/tables'
      fullPath: '/components/tables'
      preLoaderRoute: typeof AuthenticatedLayoutComponentsTablesRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/components/typography': {
      id: '/_authenticated/_layout/components/typography'
      path: '/components/typography'
      fullPath: '/components/typography'
      preLoaderRoute: typeof AuthenticatedLayoutComponentsTypographyRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/components/wizards': {
      id: '/_authenticated/_layout/components/wizards'
      path: '/components/wizards'
      fullPath: '/components/wizards'
      preLoaderRoute: typeof AuthenticatedLayoutComponentsWizardsRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/meta-campaigns/': {
      id: '/_authenticated/_layout/meta-campaigns/'
      path: '/meta-campaigns'
      fullPath: '/meta-campaigns/'
      preLoaderRoute: typeof AuthenticatedLayoutMetaCampaignsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/notifications/': {
      id: '/_authenticated/_layout/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof AuthenticatedLayoutNotificationsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/notifications/$notificationId': {
      id: '/_authenticated/_layout/notifications/$notificationId'
      path: '/notifications/$notificationId'
      fullPath: '/notifications/$notificationId'
      preLoaderRoute: typeof AuthenticatedLayoutNotificationsNotificationIdRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/optimizations/': {
      id: '/_authenticated/_layout/optimizations/'
      path: '/optimizations'
      fullPath: '/optimizations/'
      preLoaderRoute: typeof AuthenticatedLayoutOptimizationsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/organizations/': {
      id: '/_authenticated/_layout/organizations/'
      path: '/organizations'
      fullPath: '/organizations/'
      preLoaderRoute: typeof AuthenticatedLayoutOrganizationsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/organizations/$orgId': {
      id: '/_authenticated/_layout/organizations/$orgId'
      path: '/organizations/$orgId'
      fullPath: '/organizations/$orgId'
      preLoaderRoute: typeof AuthenticatedLayoutOrganizationsOrgIdRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/performance-beta/': {
      id: '/_authenticated/_layout/performance-beta/'
      path: '/performance-beta'
      fullPath: '/performance-beta/'
      preLoaderRoute: typeof AuthenticatedLayoutPerformanceBetaIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/performance-consolidated/': {
      id: '/_authenticated/_layout/performance-consolidated/'
      path: '/performance-consolidated'
      fullPath: '/performance-consolidated/'
      preLoaderRoute: typeof AuthenticatedLayoutPerformanceConsolidatedIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/performance/': {
      id: '/_authenticated/_layout/performance/'
      path: '/'
      fullPath: '/performance/'
      preLoaderRoute: typeof AuthenticatedLayoutPerformanceIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutPerformanceRouteRoute
    }
    '/_authenticated/_layout/reports/': {
      id: '/_authenticated/_layout/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthenticatedLayoutReportsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/reports/$reportId': {
      id: '/_authenticated/_layout/reports/$reportId'
      path: '/reports/$reportId'
      fullPath: '/reports/$reportId'
      preLoaderRoute: typeof AuthenticatedLayoutReportsReportIdRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/settings/': {
      id: '/_authenticated/_layout/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedLayoutSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/settings/_layout': {
      id: '/_authenticated/_layout/settings/_layout'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedLayoutSettingsLayoutRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/setup/': {
      id: '/_authenticated/_layout/setup/'
      path: '/setup'
      fullPath: '/setup/'
      preLoaderRoute: typeof AuthenticatedLayoutSetupIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/strategy/': {
      id: '/_authenticated/_layout/strategy/'
      path: '/strategy'
      fullPath: '/strategy/'
      preLoaderRoute: typeof AuthenticatedLayoutStrategyIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/tasks/': {
      id: '/_authenticated/_layout/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AuthenticatedLayoutTasksIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/tasks/_layout': {
      id: '/_authenticated/_layout/tasks/_layout'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthenticatedLayoutTasksLayoutRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/new/_layout/brand': {
      id: '/_authenticated/new/_layout/brand'
      path: '/brand'
      fullPath: '/new/brand'
      preLoaderRoute: typeof AuthenticatedNewLayoutBrandRouteImport
      parentRoute: typeof AuthenticatedNewLayoutRoute
    }
    '/_authenticated/_layout/campaigns/meta/$metaCampaignSlug': {
      id: '/_authenticated/_layout/campaigns/meta/$metaCampaignSlug'
      path: '/meta/$metaCampaignSlug'
      fullPath: '/campaigns/meta/$metaCampaignSlug'
      preLoaderRoute: typeof AuthenticatedLayoutCampaignsMetaMetaCampaignSlugRouteImport
      parentRoute: typeof AuthenticatedLayoutCampaignsRouteRoute
    }
    '/_authenticated/_layout/performance/$campaignSlug/': {
      id: '/_authenticated/_layout/performance/$campaignSlug/'
      path: '/$campaignSlug'
      fullPath: '/performance/$campaignSlug/'
      preLoaderRoute: typeof AuthenticatedLayoutPerformanceCampaignSlugIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutPerformanceRouteRoute
    }
    '/_authenticated/_layout/settings/_layout/account': {
      id: '/_authenticated/_layout/settings/_layout/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedLayoutSettingsLayoutAccountRouteImport
      parentRoute: typeof AuthenticatedLayoutSettingsLayoutRoute
    }
    '/_authenticated/_layout/settings/_layout/billing': {
      id: '/_authenticated/_layout/settings/_layout/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthenticatedLayoutSettingsLayoutBillingRouteImport
      parentRoute: typeof AuthenticatedLayoutSettingsLayoutRoute
    }
    '/_authenticated/_layout/settings/_layout/budget': {
      id: '/_authenticated/_layout/settings/_layout/budget'
      path: '/budget'
      fullPath: '/settings/budget'
      preLoaderRoute: typeof AuthenticatedLayoutSettingsLayoutBudgetRouteImport
      parentRoute: typeof AuthenticatedLayoutSettingsLayoutRoute
    }
    '/_authenticated/_layout/settings/_layout/company': {
      id: '/_authenticated/_layout/settings/_layout/company'
      path: '/company'
      fullPath: '/settings/company'
      preLoaderRoute: typeof AuthenticatedLayoutSettingsLayoutCompanyRouteImport
      parentRoute: typeof AuthenticatedLayoutSettingsLayoutRoute
    }
    '/_authenticated/_layout/settings/_layout/conversions': {
      id: '/_authenticated/_layout/settings/_layout/conversions'
      path: '/conversions'
      fullPath: '/settings/conversions'
      preLoaderRoute: typeof AuthenticatedLayoutSettingsLayoutConversionsRouteImport
      parentRoute: typeof AuthenticatedLayoutSettingsLayoutRoute
    }
    '/_authenticated/_layout/settings/_layout/integrations': {
      id: '/_authenticated/_layout/settings/_layout/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AuthenticatedLayoutSettingsLayoutIntegrationsRouteImport
      parentRoute: typeof AuthenticatedLayoutSettingsLayoutRoute
    }
    '/_authenticated/_layout/settings/_layout/notification': {
      id: '/_authenticated/_layout/settings/_layout/notification'
      path: '/notification'
      fullPath: '/settings/notification'
      preLoaderRoute: typeof AuthenticatedLayoutSettingsLayoutNotificationRouteImport
      parentRoute: typeof AuthenticatedLayoutSettingsLayoutRoute
    }
    '/_authenticated/_layout/settings/_layout/reports': {
      id: '/_authenticated/_layout/settings/_layout/reports'
      path: '/reports'
      fullPath: '/settings/reports'
      preLoaderRoute: typeof AuthenticatedLayoutSettingsLayoutReportsRouteImport
      parentRoute: typeof AuthenticatedLayoutSettingsLayoutRoute
    }
    '/_authenticated/_layout/settings/_layout/team': {
      id: '/_authenticated/_layout/settings/_layout/team'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof AuthenticatedLayoutSettingsLayoutTeamRouteImport
      parentRoute: typeof AuthenticatedLayoutSettingsLayoutRoute
    }
    '/_authenticated/_layout/tasks/_layout/negative-keywords': {
      id: '/_authenticated/_layout/tasks/_layout/negative-keywords'
      path: '/negative-keywords'
      fullPath: '/tasks/negative-keywords'
      preLoaderRoute: typeof AuthenticatedLayoutTasksLayoutNegativeKeywordsRouteImport
      parentRoute: typeof AuthenticatedLayoutTasksLayoutRoute
    }
    '/_authenticated/_layout/tasks/_layout/new': {
      id: '/_authenticated/_layout/tasks/_layout/new'
      path: '/new'
      fullPath: '/tasks/new'
      preLoaderRoute: typeof AuthenticatedLayoutTasksLayoutNewRouteImport
      parentRoute: typeof AuthenticatedLayoutTasksLayoutRoute
    }
    '/_authenticated/_layout/tasks/_layout/recommendations': {
      id: '/_authenticated/_layout/tasks/_layout/recommendations'
      path: '/recommendations'
      fullPath: '/tasks/recommendations'
      preLoaderRoute: typeof AuthenticatedLayoutTasksLayoutRecommendationsRouteImport
      parentRoute: typeof AuthenticatedLayoutTasksLayoutRoute
    }
    '/_authenticated/new/_layout/$campaignslug/generating': {
      id: '/_authenticated/new/_layout/$campaignslug/generating'
      path: '/$campaignslug/generating'
      fullPath: '/new/$campaignslug/generating'
      preLoaderRoute: typeof AuthenticatedNewLayoutCampaignslugGeneratingRouteImport
      parentRoute: typeof AuthenticatedNewLayoutRoute
    }
    '/_authenticated/new/_layout/campaign/': {
      id: '/_authenticated/new/_layout/campaign/'
      path: '/campaign'
      fullPath: '/new/campaign/'
      preLoaderRoute: typeof AuthenticatedNewLayoutCampaignIndexRouteImport
      parentRoute: typeof AuthenticatedNewLayoutRoute
    }
    '/_authenticated/new/_layout/campaign/brand': {
      id: '/_authenticated/new/_layout/campaign/brand'
      path: '/campaign/brand'
      fullPath: '/new/campaign/brand'
      preLoaderRoute: typeof AuthenticatedNewLayoutCampaignBrandRouteImport
      parentRoute: typeof AuthenticatedNewLayoutRoute
    }
    '/_authenticated/new/_layout/campaign/competitor': {
      id: '/_authenticated/new/_layout/campaign/competitor'
      path: '/campaign/competitor'
      fullPath: '/new/campaign/competitor'
      preLoaderRoute: typeof AuthenticatedNewLayoutCampaignCompetitorRouteImport
      parentRoute: typeof AuthenticatedNewLayoutRoute
    }
    '/_authenticated/new/_layout/campaign/hipo': {
      id: '/_authenticated/new/_layout/campaign/hipo'
      path: '/campaign/hipo'
      fullPath: '/new/campaign/hipo'
      preLoaderRoute: typeof AuthenticatedNewLayoutCampaignHipoRouteImport
      parentRoute: typeof AuthenticatedNewLayoutRoute
    }
    '/_authenticated/new/_layout/campaign/icp': {
      id: '/_authenticated/new/_layout/campaign/icp'
      path: '/campaign/icp'
      fullPath: '/new/campaign/icp'
      preLoaderRoute: typeof AuthenticatedNewLayoutCampaignIcpRouteImport
      parentRoute: typeof AuthenticatedNewLayoutRoute
    }
    '/_authenticated/new/_layout/campaign/location': {
      id: '/_authenticated/new/_layout/campaign/location'
      path: '/campaign/location'
      fullPath: '/new/campaign/location'
      preLoaderRoute: typeof AuthenticatedNewLayoutCampaignLocationRouteImport
      parentRoute: typeof AuthenticatedNewLayoutRoute
    }
    '/_authenticated/new/_layout/campaign/meta': {
      id: '/_authenticated/new/_layout/campaign/meta'
      path: '/campaign/meta'
      fullPath: '/new/campaign/meta'
      preLoaderRoute: typeof AuthenticatedNewLayoutCampaignMetaRouteImport
      parentRoute: typeof AuthenticatedNewLayoutRoute
    }
    '/_authenticated/new/_layout/campaign/prospecting': {
      id: '/_authenticated/new/_layout/campaign/prospecting'
      path: '/campaign/prospecting'
      fullPath: '/new/campaign/prospecting'
      preLoaderRoute: typeof AuthenticatedNewLayoutCampaignProspectingRouteImport
      parentRoute: typeof AuthenticatedNewLayoutRoute
    }
    '/_authenticated/new/_layout/deploying/$slug': {
      id: '/_authenticated/new/_layout/deploying/$slug'
      path: '/deploying/$slug'
      fullPath: '/new/deploying/$slug'
      preLoaderRoute: typeof AuthenticatedNewLayoutDeployingSlugRouteImport
      parentRoute: typeof AuthenticatedNewLayoutRoute
    }
    '/_authenticated/new/_layout/onboarding/': {
      id: '/_authenticated/new/_layout/onboarding/'
      path: '/onboarding'
      fullPath: '/new/onboarding/'
      preLoaderRoute: typeof AuthenticatedNewLayoutOnboardingIndexRouteImport
      parentRoute: typeof AuthenticatedNewLayoutRoute
    }
    '/_authenticated/new/_layout/onboarding/generating': {
      id: '/_authenticated/new/_layout/onboarding/generating'
      path: '/onboarding/generating'
      fullPath: '/new/onboarding/generating'
      preLoaderRoute: typeof AuthenticatedNewLayoutOnboardingGeneratingRouteImport
      parentRoute: typeof AuthenticatedNewLayoutRoute
    }
    '/_authenticated/_layout/campaigns/google/$campaignslug/_slug': {
      id: '/_authenticated/_layout/campaigns/google/$campaignslug/_slug'
      path: '/google/$campaignslug'
      fullPath: '/campaigns/google/$campaignslug'
      preLoaderRoute: typeof AuthenticatedLayoutCampaignsGoogleCampaignslugSlugRouteImport
      parentRoute: typeof AuthenticatedLayoutCampaignsRouteRoute
    }
    '/_authenticated/_layout/campaigns/google/$campaignslug/_slug/': {
      id: '/_authenticated/_layout/campaigns/google/$campaignslug/_slug/'
      path: '/'
      fullPath: '/campaigns/google/$campaignslug/'
      preLoaderRoute: typeof AuthenticatedLayoutCampaignsGoogleCampaignslugSlugIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutCampaignsGoogleCampaignslugSlugRoute
    }
    '/_authenticated/_layout/campaigns/meta/$metaCampaignSlug_/ad/$adId': {
      id: '/_authenticated/_layout/campaigns/meta/$metaCampaignSlug_/ad/$adId'
      path: '/meta/$metaCampaignSlug/ad/$adId'
      fullPath: '/campaigns/meta/$metaCampaignSlug/ad/$adId'
      preLoaderRoute: typeof AuthenticatedLayoutCampaignsMetaMetaCampaignSlugAdAdIdRouteImport
      parentRoute: typeof AuthenticatedLayoutCampaignsRouteRoute
    }
    '/_authenticated/_layout/campaigns/meta/$metaCampaignSlug_/adset/$adSetId': {
      id: '/_authenticated/_layout/campaigns/meta/$metaCampaignSlug_/adset/$adSetId'
      path: '/meta/$metaCampaignSlug/adset/$adSetId'
      fullPath: '/campaigns/meta/$metaCampaignSlug/adset/$adSetId'
      preLoaderRoute: typeof AuthenticatedLayoutCampaignsMetaMetaCampaignSlugAdsetAdSetIdRouteImport
      parentRoute: typeof AuthenticatedLayoutCampaignsRouteRoute
    }
    '/_authenticated/_layout/settings/_layout/integrations/hubspot/callback': {
      id: '/_authenticated/_layout/settings/_layout/integrations/hubspot/callback'
      path: '/hubspot/callback'
      fullPath: '/settings/integrations/hubspot/callback'
      preLoaderRoute: typeof AuthenticatedLayoutSettingsLayoutIntegrationsHubspotCallbackRouteImport
      parentRoute: typeof AuthenticatedLayoutSettingsLayoutIntegrationsRoute
    }
    '/_authenticated/_layout/settings/_layout/integrations/meta/callback': {
      id: '/_authenticated/_layout/settings/_layout/integrations/meta/callback'
      path: '/meta/callback'
      fullPath: '/settings/integrations/meta/callback'
      preLoaderRoute: typeof AuthenticatedLayoutSettingsLayoutIntegrationsMetaCallbackRouteImport
      parentRoute: typeof AuthenticatedLayoutSettingsLayoutIntegrationsRoute
    }
    '/_authenticated/_layout/campaigns/google/$campaignslug/_slug/ad/$adId': {
      id: '/_authenticated/_layout/campaigns/google/$campaignslug/_slug/ad/$adId'
      path: '/ad/$adId'
      fullPath: '/campaigns/google/$campaignslug/ad/$adId'
      preLoaderRoute: typeof AuthenticatedLayoutCampaignsGoogleCampaignslugSlugAdAdIdRouteImport
      parentRoute: typeof AuthenticatedLayoutCampaignsGoogleCampaignslugSlugRoute
    }
  }
}

interface AuthenticatedLayoutCampaignsGoogleCampaignslugSlugRouteChildren {
  AuthenticatedLayoutCampaignsGoogleCampaignslugSlugIndexRoute: typeof AuthenticatedLayoutCampaignsGoogleCampaignslugSlugIndexRoute
  AuthenticatedLayoutCampaignsGoogleCampaignslugSlugAdAdIdRoute: typeof AuthenticatedLayoutCampaignsGoogleCampaignslugSlugAdAdIdRoute
}

const AuthenticatedLayoutCampaignsGoogleCampaignslugSlugRouteChildren: AuthenticatedLayoutCampaignsGoogleCampaignslugSlugRouteChildren =
  {
    AuthenticatedLayoutCampaignsGoogleCampaignslugSlugIndexRoute:
      AuthenticatedLayoutCampaignsGoogleCampaignslugSlugIndexRoute,
    AuthenticatedLayoutCampaignsGoogleCampaignslugSlugAdAdIdRoute:
      AuthenticatedLayoutCampaignsGoogleCampaignslugSlugAdAdIdRoute,
  }

const AuthenticatedLayoutCampaignsGoogleCampaignslugSlugRouteWithChildren =
  AuthenticatedLayoutCampaignsGoogleCampaignslugSlugRoute._addFileChildren(
    AuthenticatedLayoutCampaignsGoogleCampaignslugSlugRouteChildren,
  )

interface AuthenticatedLayoutCampaignsRouteRouteChildren {
  AuthenticatedLayoutCampaignsCampaignslugRoute: typeof AuthenticatedLayoutCampaignsCampaignslugRoute
  AuthenticatedLayoutCampaignsIndexRoute: typeof AuthenticatedLayoutCampaignsIndexRoute
  AuthenticatedLayoutCampaignsMetaMetaCampaignSlugRoute: typeof AuthenticatedLayoutCampaignsMetaMetaCampaignSlugRoute
  AuthenticatedLayoutCampaignsGoogleCampaignslugSlugRoute: typeof AuthenticatedLayoutCampaignsGoogleCampaignslugSlugRouteWithChildren
  AuthenticatedLayoutCampaignsMetaMetaCampaignSlugAdAdIdRoute: typeof AuthenticatedLayoutCampaignsMetaMetaCampaignSlugAdAdIdRoute
  AuthenticatedLayoutCampaignsMetaMetaCampaignSlugAdsetAdSetIdRoute: typeof AuthenticatedLayoutCampaignsMetaMetaCampaignSlugAdsetAdSetIdRoute
}

const AuthenticatedLayoutCampaignsRouteRouteChildren: AuthenticatedLayoutCampaignsRouteRouteChildren =
  {
    AuthenticatedLayoutCampaignsCampaignslugRoute:
      AuthenticatedLayoutCampaignsCampaignslugRoute,
    AuthenticatedLayoutCampaignsIndexRoute:
      AuthenticatedLayoutCampaignsIndexRoute,
    AuthenticatedLayoutCampaignsMetaMetaCampaignSlugRoute:
      AuthenticatedLayoutCampaignsMetaMetaCampaignSlugRoute,
    AuthenticatedLayoutCampaignsGoogleCampaignslugSlugRoute:
      AuthenticatedLayoutCampaignsGoogleCampaignslugSlugRouteWithChildren,
    AuthenticatedLayoutCampaignsMetaMetaCampaignSlugAdAdIdRoute:
      AuthenticatedLayoutCampaignsMetaMetaCampaignSlugAdAdIdRoute,
    AuthenticatedLayoutCampaignsMetaMetaCampaignSlugAdsetAdSetIdRoute:
      AuthenticatedLayoutCampaignsMetaMetaCampaignSlugAdsetAdSetIdRoute,
  }

const AuthenticatedLayoutCampaignsRouteRouteWithChildren =
  AuthenticatedLayoutCampaignsRouteRoute._addFileChildren(
    AuthenticatedLayoutCampaignsRouteRouteChildren,
  )

interface AuthenticatedLayoutPerformanceRouteRouteChildren {
  AuthenticatedLayoutPerformanceIndexRoute: typeof AuthenticatedLayoutPerformanceIndexRoute
  AuthenticatedLayoutPerformanceCampaignSlugIndexRoute: typeof AuthenticatedLayoutPerformanceCampaignSlugIndexRoute
}

const AuthenticatedLayoutPerformanceRouteRouteChildren: AuthenticatedLayoutPerformanceRouteRouteChildren =
  {
    AuthenticatedLayoutPerformanceIndexRoute:
      AuthenticatedLayoutPerformanceIndexRoute,
    AuthenticatedLayoutPerformanceCampaignSlugIndexRoute:
      AuthenticatedLayoutPerformanceCampaignSlugIndexRoute,
  }

const AuthenticatedLayoutPerformanceRouteRouteWithChildren =
  AuthenticatedLayoutPerformanceRouteRoute._addFileChildren(
    AuthenticatedLayoutPerformanceRouteRouteChildren,
  )

interface AuthenticatedLayoutSettingsLayoutIntegrationsRouteChildren {
  AuthenticatedLayoutSettingsLayoutIntegrationsHubspotCallbackRoute: typeof AuthenticatedLayoutSettingsLayoutIntegrationsHubspotCallbackRoute
  AuthenticatedLayoutSettingsLayoutIntegrationsMetaCallbackRoute: typeof AuthenticatedLayoutSettingsLayoutIntegrationsMetaCallbackRoute
}

const AuthenticatedLayoutSettingsLayoutIntegrationsRouteChildren: AuthenticatedLayoutSettingsLayoutIntegrationsRouteChildren =
  {
    AuthenticatedLayoutSettingsLayoutIntegrationsHubspotCallbackRoute:
      AuthenticatedLayoutSettingsLayoutIntegrationsHubspotCallbackRoute,
    AuthenticatedLayoutSettingsLayoutIntegrationsMetaCallbackRoute:
      AuthenticatedLayoutSettingsLayoutIntegrationsMetaCallbackRoute,
  }

const AuthenticatedLayoutSettingsLayoutIntegrationsRouteWithChildren =
  AuthenticatedLayoutSettingsLayoutIntegrationsRoute._addFileChildren(
    AuthenticatedLayoutSettingsLayoutIntegrationsRouteChildren,
  )

interface AuthenticatedLayoutSettingsLayoutRouteChildren {
  AuthenticatedLayoutSettingsLayoutAccountRoute: typeof AuthenticatedLayoutSettingsLayoutAccountRoute
  AuthenticatedLayoutSettingsLayoutBillingRoute: typeof AuthenticatedLayoutSettingsLayoutBillingRoute
  AuthenticatedLayoutSettingsLayoutBudgetRoute: typeof AuthenticatedLayoutSettingsLayoutBudgetRoute
  AuthenticatedLayoutSettingsLayoutCompanyRoute: typeof AuthenticatedLayoutSettingsLayoutCompanyRoute
  AuthenticatedLayoutSettingsLayoutConversionsRoute: typeof AuthenticatedLayoutSettingsLayoutConversionsRoute
  AuthenticatedLayoutSettingsLayoutIntegrationsRoute: typeof AuthenticatedLayoutSettingsLayoutIntegrationsRouteWithChildren
  AuthenticatedLayoutSettingsLayoutNotificationRoute: typeof AuthenticatedLayoutSettingsLayoutNotificationRoute
  AuthenticatedLayoutSettingsLayoutReportsRoute: typeof AuthenticatedLayoutSettingsLayoutReportsRoute
  AuthenticatedLayoutSettingsLayoutTeamRoute: typeof AuthenticatedLayoutSettingsLayoutTeamRoute
}

const AuthenticatedLayoutSettingsLayoutRouteChildren: AuthenticatedLayoutSettingsLayoutRouteChildren =
  {
    AuthenticatedLayoutSettingsLayoutAccountRoute:
      AuthenticatedLayoutSettingsLayoutAccountRoute,
    AuthenticatedLayoutSettingsLayoutBillingRoute:
      AuthenticatedLayoutSettingsLayoutBillingRoute,
    AuthenticatedLayoutSettingsLayoutBudgetRoute:
      AuthenticatedLayoutSettingsLayoutBudgetRoute,
    AuthenticatedLayoutSettingsLayoutCompanyRoute:
      AuthenticatedLayoutSettingsLayoutCompanyRoute,
    AuthenticatedLayoutSettingsLayoutConversionsRoute:
      AuthenticatedLayoutSettingsLayoutConversionsRoute,
    AuthenticatedLayoutSettingsLayoutIntegrationsRoute:
      AuthenticatedLayoutSettingsLayoutIntegrationsRouteWithChildren,
    AuthenticatedLayoutSettingsLayoutNotificationRoute:
      AuthenticatedLayoutSettingsLayoutNotificationRoute,
    AuthenticatedLayoutSettingsLayoutReportsRoute:
      AuthenticatedLayoutSettingsLayoutReportsRoute,
    AuthenticatedLayoutSettingsLayoutTeamRoute:
      AuthenticatedLayoutSettingsLayoutTeamRoute,
  }

const AuthenticatedLayoutSettingsLayoutRouteWithChildren =
  AuthenticatedLayoutSettingsLayoutRoute._addFileChildren(
    AuthenticatedLayoutSettingsLayoutRouteChildren,
  )

interface AuthenticatedLayoutTasksLayoutRouteChildren {
  AuthenticatedLayoutTasksLayoutNegativeKeywordsRoute: typeof AuthenticatedLayoutTasksLayoutNegativeKeywordsRoute
  AuthenticatedLayoutTasksLayoutNewRoute: typeof AuthenticatedLayoutTasksLayoutNewRoute
  AuthenticatedLayoutTasksLayoutRecommendationsRoute: typeof AuthenticatedLayoutTasksLayoutRecommendationsRoute
}

const AuthenticatedLayoutTasksLayoutRouteChildren: AuthenticatedLayoutTasksLayoutRouteChildren =
  {
    AuthenticatedLayoutTasksLayoutNegativeKeywordsRoute:
      AuthenticatedLayoutTasksLayoutNegativeKeywordsRoute,
    AuthenticatedLayoutTasksLayoutNewRoute:
      AuthenticatedLayoutTasksLayoutNewRoute,
    AuthenticatedLayoutTasksLayoutRecommendationsRoute:
      AuthenticatedLayoutTasksLayoutRecommendationsRoute,
  }

const AuthenticatedLayoutTasksLayoutRouteWithChildren =
  AuthenticatedLayoutTasksLayoutRoute._addFileChildren(
    AuthenticatedLayoutTasksLayoutRouteChildren,
  )

interface AuthenticatedLayoutRouteChildren {
  AuthenticatedLayoutCampaignsRouteRoute: typeof AuthenticatedLayoutCampaignsRouteRouteWithChildren
  AuthenticatedLayoutPerformanceRouteRoute: typeof AuthenticatedLayoutPerformanceRouteRouteWithChildren
  AuthenticatedLayoutIndexRoute: typeof AuthenticatedLayoutIndexRoute
  AuthenticatedLayoutAdminKeywordsRoute: typeof AuthenticatedLayoutAdminKeywordsRoute
  AuthenticatedLayoutAdminSchedulerRoute: typeof AuthenticatedLayoutAdminSchedulerRoute
  AuthenticatedLayoutBusinessOrgIdRoute: typeof AuthenticatedLayoutBusinessOrgIdRoute
  AuthenticatedLayoutCompetitorsCompetitorIdRoute: typeof AuthenticatedLayoutCompetitorsCompetitorIdRoute
  AuthenticatedLayoutComponentsAnimationsRoute: typeof AuthenticatedLayoutComponentsAnimationsRoute
  AuthenticatedLayoutComponentsButtonsRoute: typeof AuthenticatedLayoutComponentsButtonsRoute
  AuthenticatedLayoutComponentsColorsRoute: typeof AuthenticatedLayoutComponentsColorsRoute
  AuthenticatedLayoutComponentsFormsRoute: typeof AuthenticatedLayoutComponentsFormsRoute
  AuthenticatedLayoutComponentsIconographyRoute: typeof AuthenticatedLayoutComponentsIconographyRoute
  AuthenticatedLayoutComponentsTablesRoute: typeof AuthenticatedLayoutComponentsTablesRoute
  AuthenticatedLayoutComponentsTypographyRoute: typeof AuthenticatedLayoutComponentsTypographyRoute
  AuthenticatedLayoutComponentsWizardsRoute: typeof AuthenticatedLayoutComponentsWizardsRoute
  AuthenticatedLayoutNotificationsNotificationIdRoute: typeof AuthenticatedLayoutNotificationsNotificationIdRoute
  AuthenticatedLayoutOrganizationsOrgIdRoute: typeof AuthenticatedLayoutOrganizationsOrgIdRoute
  AuthenticatedLayoutReportsReportIdRoute: typeof AuthenticatedLayoutReportsReportIdRoute
  AuthenticatedLayoutSettingsLayoutRoute: typeof AuthenticatedLayoutSettingsLayoutRouteWithChildren
  AuthenticatedLayoutTasksLayoutRoute: typeof AuthenticatedLayoutTasksLayoutRouteWithChildren
  AuthenticatedLayoutAdminIndexRoute: typeof AuthenticatedLayoutAdminIndexRoute
  AuthenticatedLayoutAssetsIndexRoute: typeof AuthenticatedLayoutAssetsIndexRoute
  AuthenticatedLayoutBusinessIndexRoute: typeof AuthenticatedLayoutBusinessIndexRoute
  AuthenticatedLayoutCompetitorsIndexRoute: typeof AuthenticatedLayoutCompetitorsIndexRoute
  AuthenticatedLayoutComponentsIndexRoute: typeof AuthenticatedLayoutComponentsIndexRoute
  AuthenticatedLayoutMetaCampaignsIndexRoute: typeof AuthenticatedLayoutMetaCampaignsIndexRoute
  AuthenticatedLayoutNotificationsIndexRoute: typeof AuthenticatedLayoutNotificationsIndexRoute
  AuthenticatedLayoutOptimizationsIndexRoute: typeof AuthenticatedLayoutOptimizationsIndexRoute
  AuthenticatedLayoutOrganizationsIndexRoute: typeof AuthenticatedLayoutOrganizationsIndexRoute
  AuthenticatedLayoutPerformanceBetaIndexRoute: typeof AuthenticatedLayoutPerformanceBetaIndexRoute
  AuthenticatedLayoutPerformanceConsolidatedIndexRoute: typeof AuthenticatedLayoutPerformanceConsolidatedIndexRoute
  AuthenticatedLayoutReportsIndexRoute: typeof AuthenticatedLayoutReportsIndexRoute
  AuthenticatedLayoutSettingsIndexRoute: typeof AuthenticatedLayoutSettingsIndexRoute
  AuthenticatedLayoutSetupIndexRoute: typeof AuthenticatedLayoutSetupIndexRoute
  AuthenticatedLayoutStrategyIndexRoute: typeof AuthenticatedLayoutStrategyIndexRoute
  AuthenticatedLayoutTasksIndexRoute: typeof AuthenticatedLayoutTasksIndexRoute
}

const AuthenticatedLayoutRouteChildren: AuthenticatedLayoutRouteChildren = {
  AuthenticatedLayoutCampaignsRouteRoute:
    AuthenticatedLayoutCampaignsRouteRouteWithChildren,
  AuthenticatedLayoutPerformanceRouteRoute:
    AuthenticatedLayoutPerformanceRouteRouteWithChildren,
  AuthenticatedLayoutIndexRoute: AuthenticatedLayoutIndexRoute,
  AuthenticatedLayoutAdminKeywordsRoute: AuthenticatedLayoutAdminKeywordsRoute,
  AuthenticatedLayoutAdminSchedulerRoute:
    AuthenticatedLayoutAdminSchedulerRoute,
  AuthenticatedLayoutBusinessOrgIdRoute: AuthenticatedLayoutBusinessOrgIdRoute,
  AuthenticatedLayoutCompetitorsCompetitorIdRoute:
    AuthenticatedLayoutCompetitorsCompetitorIdRoute,
  AuthenticatedLayoutComponentsAnimationsRoute:
    AuthenticatedLayoutComponentsAnimationsRoute,
  AuthenticatedLayoutComponentsButtonsRoute:
    AuthenticatedLayoutComponentsButtonsRoute,
  AuthenticatedLayoutComponentsColorsRoute:
    AuthenticatedLayoutComponentsColorsRoute,
  AuthenticatedLayoutComponentsFormsRoute:
    AuthenticatedLayoutComponentsFormsRoute,
  AuthenticatedLayoutComponentsIconographyRoute:
    AuthenticatedLayoutComponentsIconographyRoute,
  AuthenticatedLayoutComponentsTablesRoute:
    AuthenticatedLayoutComponentsTablesRoute,
  AuthenticatedLayoutComponentsTypographyRoute:
    AuthenticatedLayoutComponentsTypographyRoute,
  AuthenticatedLayoutComponentsWizardsRoute:
    AuthenticatedLayoutComponentsWizardsRoute,
  AuthenticatedLayoutNotificationsNotificationIdRoute:
    AuthenticatedLayoutNotificationsNotificationIdRoute,
  AuthenticatedLayoutOrganizationsOrgIdRoute:
    AuthenticatedLayoutOrganizationsOrgIdRoute,
  AuthenticatedLayoutReportsReportIdRoute:
    AuthenticatedLayoutReportsReportIdRoute,
  AuthenticatedLayoutSettingsLayoutRoute:
    AuthenticatedLayoutSettingsLayoutRouteWithChildren,
  AuthenticatedLayoutTasksLayoutRoute:
    AuthenticatedLayoutTasksLayoutRouteWithChildren,
  AuthenticatedLayoutAdminIndexRoute: AuthenticatedLayoutAdminIndexRoute,
  AuthenticatedLayoutAssetsIndexRoute: AuthenticatedLayoutAssetsIndexRoute,
  AuthenticatedLayoutBusinessIndexRoute: AuthenticatedLayoutBusinessIndexRoute,
  AuthenticatedLayoutCompetitorsIndexRoute:
    AuthenticatedLayoutCompetitorsIndexRoute,
  AuthenticatedLayoutComponentsIndexRoute:
    AuthenticatedLayoutComponentsIndexRoute,
  AuthenticatedLayoutMetaCampaignsIndexRoute:
    AuthenticatedLayoutMetaCampaignsIndexRoute,
  AuthenticatedLayoutNotificationsIndexRoute:
    AuthenticatedLayoutNotificationsIndexRoute,
  AuthenticatedLayoutOptimizationsIndexRoute:
    AuthenticatedLayoutOptimizationsIndexRoute,
  AuthenticatedLayoutOrganizationsIndexRoute:
    AuthenticatedLayoutOrganizationsIndexRoute,
  AuthenticatedLayoutPerformanceBetaIndexRoute:
    AuthenticatedLayoutPerformanceBetaIndexRoute,
  AuthenticatedLayoutPerformanceConsolidatedIndexRoute:
    AuthenticatedLayoutPerformanceConsolidatedIndexRoute,
  AuthenticatedLayoutReportsIndexRoute: AuthenticatedLayoutReportsIndexRoute,
  AuthenticatedLayoutSettingsIndexRoute: AuthenticatedLayoutSettingsIndexRoute,
  AuthenticatedLayoutSetupIndexRoute: AuthenticatedLayoutSetupIndexRoute,
  AuthenticatedLayoutStrategyIndexRoute: AuthenticatedLayoutStrategyIndexRoute,
  AuthenticatedLayoutTasksIndexRoute: AuthenticatedLayoutTasksIndexRoute,
}

const AuthenticatedLayoutRouteWithChildren =
  AuthenticatedLayoutRoute._addFileChildren(AuthenticatedLayoutRouteChildren)

interface AuthenticatedNewLayoutRouteChildren {
  AuthenticatedNewLayoutBrandRoute: typeof AuthenticatedNewLayoutBrandRoute
  AuthenticatedNewLayoutCampaignslugGeneratingRoute: typeof AuthenticatedNewLayoutCampaignslugGeneratingRoute
  AuthenticatedNewLayoutCampaignBrandRoute: typeof AuthenticatedNewLayoutCampaignBrandRoute
  AuthenticatedNewLayoutCampaignCompetitorRoute: typeof AuthenticatedNewLayoutCampaignCompetitorRoute
  AuthenticatedNewLayoutCampaignHipoRoute: typeof AuthenticatedNewLayoutCampaignHipoRoute
  AuthenticatedNewLayoutCampaignIcpRoute: typeof AuthenticatedNewLayoutCampaignIcpRoute
  AuthenticatedNewLayoutCampaignLocationRoute: typeof AuthenticatedNewLayoutCampaignLocationRoute
  AuthenticatedNewLayoutCampaignMetaRoute: typeof AuthenticatedNewLayoutCampaignMetaRoute
  AuthenticatedNewLayoutCampaignProspectingRoute: typeof AuthenticatedNewLayoutCampaignProspectingRoute
  AuthenticatedNewLayoutDeployingSlugRoute: typeof AuthenticatedNewLayoutDeployingSlugRoute
  AuthenticatedNewLayoutOnboardingGeneratingRoute: typeof AuthenticatedNewLayoutOnboardingGeneratingRoute
  AuthenticatedNewLayoutCampaignIndexRoute: typeof AuthenticatedNewLayoutCampaignIndexRoute
  AuthenticatedNewLayoutOnboardingIndexRoute: typeof AuthenticatedNewLayoutOnboardingIndexRoute
}

const AuthenticatedNewLayoutRouteChildren: AuthenticatedNewLayoutRouteChildren =
  {
    AuthenticatedNewLayoutBrandRoute: AuthenticatedNewLayoutBrandRoute,
    AuthenticatedNewLayoutCampaignslugGeneratingRoute:
      AuthenticatedNewLayoutCampaignslugGeneratingRoute,
    AuthenticatedNewLayoutCampaignBrandRoute:
      AuthenticatedNewLayoutCampaignBrandRoute,
    AuthenticatedNewLayoutCampaignCompetitorRoute:
      AuthenticatedNewLayoutCampaignCompetitorRoute,
    AuthenticatedNewLayoutCampaignHipoRoute:
      AuthenticatedNewLayoutCampaignHipoRoute,
    AuthenticatedNewLayoutCampaignIcpRoute:
      AuthenticatedNewLayoutCampaignIcpRoute,
    AuthenticatedNewLayoutCampaignLocationRoute:
      AuthenticatedNewLayoutCampaignLocationRoute,
    AuthenticatedNewLayoutCampaignMetaRoute:
      AuthenticatedNewLayoutCampaignMetaRoute,
    AuthenticatedNewLayoutCampaignProspectingRoute:
      AuthenticatedNewLayoutCampaignProspectingRoute,
    AuthenticatedNewLayoutDeployingSlugRoute:
      AuthenticatedNewLayoutDeployingSlugRoute,
    AuthenticatedNewLayoutOnboardingGeneratingRoute:
      AuthenticatedNewLayoutOnboardingGeneratingRoute,
    AuthenticatedNewLayoutCampaignIndexRoute:
      AuthenticatedNewLayoutCampaignIndexRoute,
    AuthenticatedNewLayoutOnboardingIndexRoute:
      AuthenticatedNewLayoutOnboardingIndexRoute,
  }

const AuthenticatedNewLayoutRouteWithChildren =
  AuthenticatedNewLayoutRoute._addFileChildren(
    AuthenticatedNewLayoutRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedLayoutRoute: typeof AuthenticatedLayoutRouteWithChildren
  AuthenticatedAddToCampaignRoute: typeof AuthenticatedAddToCampaignRoute
  AuthenticatedImpersonateRoute: typeof AuthenticatedImpersonateRoute
  AuthenticatedPendingInvitesRoute: typeof AuthenticatedPendingInvitesRoute
  AuthenticatedClientSlugRoute: typeof AuthenticatedClientSlugRoute
  AuthenticatedNewLayoutRoute: typeof AuthenticatedNewLayoutRouteWithChildren
  AuthenticatedWelcomeOrganizationNameRoute: typeof AuthenticatedWelcomeOrganizationNameRoute
  AuthenticatedWelcomeIndexRoute: typeof AuthenticatedWelcomeIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedLayoutRoute: AuthenticatedLayoutRouteWithChildren,
  AuthenticatedAddToCampaignRoute: AuthenticatedAddToCampaignRoute,
  AuthenticatedImpersonateRoute: AuthenticatedImpersonateRoute,
  AuthenticatedPendingInvitesRoute: AuthenticatedPendingInvitesRoute,
  AuthenticatedClientSlugRoute: AuthenticatedClientSlugRoute,
  AuthenticatedNewLayoutRoute: AuthenticatedNewLayoutRouteWithChildren,
  AuthenticatedWelcomeOrganizationNameRoute:
    AuthenticatedWelcomeOrganizationNameRoute,
  AuthenticatedWelcomeIndexRoute: AuthenticatedWelcomeIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ChartRenderRoute: ChartRenderRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  SigninRoute: SigninRoute,
  SignupRoute: SignupRoute,
  UnsubscribeRoute: UnsubscribeRoute,
  OauthConsentRoute: OauthConsentRoute,
  ResetPasswordTokenRoute: ResetPasswordTokenRoute,
  InviteSignupCodeIndexRoute: InviteSignupCodeIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
